import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BYTE: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Astute_ClientBiller = {
  __typename?: 'ASTUTE_ClientBiller';
  bid: Scalars['String']['output'];
  wid?: Maybe<Scalars['String']['output']>;
};

export enum Astute_EmployeeIdentifier {
  AtsCandidateId = 'ATS_CANDIDATE_ID',
  StandardUserUuid = 'STANDARD_USER_UUID'
}

export type Astute_IdentifierPolicy = {
  __typename?: 'ASTUTE_IdentifierPolicy';
  allowHqJobIdFallback: Scalars['Boolean']['output'];
  allowHqUserIdFallback: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  employeeIdentifier: Astute_EmployeeIdentifier;
  employeePrefix: Scalars['String']['output'];
  jobCodeDelimiter: Scalars['String']['output'];
  jobCodeOrder: Scalars['String']['output'];
  jobIdentifier: Astute_JobIdentifier;
  source: Astute_IdentifierSource;
  tenantId: Scalars['String']['output'];
  tryBareCandidateId: Scalars['Boolean']['output'];
};

export type Astute_IdentifierPolicyInput = {
  allowHqJobIdFallback?: InputMaybe<Scalars['Boolean']['input']>;
  allowHqUserIdFallback?: InputMaybe<Scalars['Boolean']['input']>;
  employeeIdentifier?: InputMaybe<Astute_EmployeeIdentifier>;
  employeePrefix?: InputMaybe<Scalars['String']['input']>;
  jobCodeDelimiter?: InputMaybe<Scalars['String']['input']>;
  jobCodeOrder?: InputMaybe<Scalars['String']['input']>;
  jobIdentifier?: InputMaybe<Astute_JobIdentifier>;
  source?: InputMaybe<Astute_IdentifierSource>;
  tryBareCandidateId?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Astute_IdentifierSource {
  Bullhorn = 'BULLHORN',
  Jobadder = 'JOBADDER',
  None = 'NONE'
}

export enum Astute_JobIdentifier {
  AtsJobAndPlacement = 'ATS_JOB_AND_PLACEMENT',
  AtsJobId = 'ATS_JOB_ID',
  StandardJobUuid = 'STANDARD_JOB_UUID'
}

export type Astute_OccupationLibrary = {
  __typename?: 'ASTUTE_OccupationLibrary';
  OL_OID: Scalars['String']['output'];
  chargeRate: Scalars['Float']['output'];
  classificationLevels?: Maybe<Array<Maybe<ClassificationLevel>>>;
  group: Scalars['String']['output'];
  name: Scalars['String']['output'];
  oncosts: Scalars['Float']['output'];
  payRate: Scalars['Float']['output'];
};

export type Astute_PayRunPreCheck = {
  __typename?: 'ASTUTE_PayRunPreCheck';
  billers: Array<Astute_PayRunPreCheckBiller>;
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  identifierPolicy: Astute_IdentifierPolicy;
  manualChanges: Array<Astute_PayRunPreCheckChange>;
  periodEndISO: Scalars['String']['output'];
  periodStartISO: Scalars['String']['output'];
  runId: Scalars['String']['output'];
  scope: Astute_PayRunPreCheckScope;
  shifts: Array<Astute_PayRunPreCheckShift>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: Astute_PayRunPreCheckStatus;
  systemChanges: Array<Astute_PayRunPreCheckChange>;
  tenantId: Scalars['String']['output'];
};

export type Astute_PayRunPreCheckBiller = {
  __typename?: 'ASTUTE_PayRunPreCheckBiller';
  astuteBid: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  matchedBy: Scalars['String']['output'];
  options: Array<Astute_PayRunPreCheckBillerOption>;
  reasons: Array<Scalars['String']['output']>;
  recommendation: Scalars['String']['output'];
  recommendedBid: Scalars['String']['output'];
  result: Scalars['String']['output'];
  storedBid: Scalars['String']['output'];
};

export type Astute_PayRunPreCheckBillerOption = {
  __typename?: 'ASTUTE_PayRunPreCheckBillerOption';
  bid: Scalars['String']['output'];
  matchedBy: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  remoteid: Scalars['String']['output'];
};

export type Astute_PayRunPreCheckChange = {
  __typename?: 'ASTUTE_PayRunPreCheckChange';
  action: Scalars['String']['output'];
  applied: Scalars['Boolean']['output'];
  astuteIds: Array<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
};

export type Astute_PayRunPreCheckScope = {
  __typename?: 'ASTUTE_PayRunPreCheckScope';
  clientCount: Scalars['Int']['output'];
  daySequenceCount: Scalars['Int']['output'];
  jobCount: Scalars['Int']['output'];
  workerCount: Scalars['Int']['output'];
};

export type Astute_PayRunPreCheckShift = {
  __typename?: 'ASTUTE_PayRunPreCheckShift';
  clientBid: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  date: Scalars['String']['output'];
  daySequenceId: Scalars['String']['output'];
  jobCode: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  jobUid: Scalars['String']['output'];
  status: Scalars['String']['output'];
  workerId: Scalars['String']['output'];
  workerMid: Scalars['String']['output'];
  workerName: Scalars['String']['output'];
};

export enum Astute_PayRunPreCheckStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  None = 'NONE',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export enum Ats_ExplorableIntegration {
  Astute = 'ASTUTE',
  Bullhorn = 'BULLHORN',
  Jobadder = 'JOBADDER'
}

export type AbsorbClientBlocker = {
  __typename?: 'AbsorbClientBlocker';
  kind: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AbsorbClientIdentity = {
  __typename?: 'AbsorbClientIdentity';
  clientId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<ClientStatus>;
};

export type AbsorbClientIntegrationReference = {
  __typename?: 'AbsorbClientIntegrationReference';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AbsorbClientMoveCounts = {
  __typename?: 'AbsorbClientMoveCounts';
  daySequenceCount: Scalars['Int']['output'];
  jobApplicationCount: Scalars['Int']['output'];
  jobCount: Scalars['Int']['output'];
  siteCount: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
};

export type AbsorbClientPrecheck = {
  __typename?: 'AbsorbClientPrecheck';
  blockers: Array<AbsorbClientBlocker>;
  blockingReasons: Array<Scalars['String']['output']>;
  canAbsorb: Scalars['Boolean']['output'];
  integrationReferences: Array<AbsorbClientIntegrationReference>;
  missingClassificationIds: Array<Scalars['String']['output']>;
  moveCounts: AbsorbClientMoveCounts;
  source?: Maybe<AbsorbClientIdentity>;
  target?: Maybe<AbsorbClientIdentity>;
};

export type AbsorbClientResult = {
  __typename?: 'AbsorbClientResult';
  moveCounts: AbsorbClientMoveCounts;
  sourceClientId: Scalars['String']['output'];
  target: Client;
  transferredIntegrationReferences: Array<AbsorbClientIntegrationReference>;
};

export type AbsorbSiteBlocker = {
  __typename?: 'AbsorbSiteBlocker';
  kind: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AbsorbSiteIdentity = {
  __typename?: 'AbsorbSiteIdentity';
  clientId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  status?: Maybe<SiteStatus>;
};

export type AbsorbSiteIntegrationReference = {
  __typename?: 'AbsorbSiteIntegrationReference';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AbsorbSiteMoveCounts = {
  __typename?: 'AbsorbSiteMoveCounts';
  jobCount: Scalars['Int']['output'];
  pendingInviteCount: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
};

export type AbsorbSitePrecheck = {
  __typename?: 'AbsorbSitePrecheck';
  blockers: Array<AbsorbSiteBlocker>;
  blockingReasons: Array<Scalars['String']['output']>;
  canAbsorb: Scalars['Boolean']['output'];
  moveCounts: AbsorbSiteMoveCounts;
  source?: Maybe<AbsorbSiteIdentity>;
  target?: Maybe<AbsorbSiteIdentity>;
  transferredIntegrationReferences: Array<AbsorbSiteIntegrationReference>;
};

export type AbsorbSiteResult = {
  __typename?: 'AbsorbSiteResult';
  moveCounts: AbsorbSiteMoveCounts;
  sourceSiteId: Scalars['String']['output'];
  target: Site;
  transferredIntegrationReferences: Array<AbsorbSiteIntegrationReference>;
};

export type Address = {
  __typename?: 'Address';
  addressFriendly?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  countryLabel?: Maybe<Scalars['String']['output']>;
  countryValue?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  addressFriendly?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  countryValue?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export enum AiPromptType {
  GenerateProfileSummary = 'GENERATE_PROFILE_SUMMARY',
  SuggestJobDescription = 'SUGGEST_JOB_DESCRIPTION',
  SuggestJobTitle = 'SUGGEST_JOB_TITLE'
}

export type AppConfig = {
  __typename?: 'AppConfig';
  androidStoreUrl?: Maybe<Scalars['String']['output']>;
  featureFlags?: Maybe<Scalars['JSON']['output']>;
  forceUpdate: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  iosStoreUrl?: Maybe<Scalars['String']['output']>;
  maintenanceEnabled: Scalars['Boolean']['output'];
  maintenanceEndTime?: Maybe<Scalars['String']['output']>;
  maintenanceMessage?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  versions: AppVersions;
};

export type AppConfigInput = {
  androidStoreUrl?: InputMaybe<Scalars['String']['input']>;
  featureFlags?: InputMaybe<Scalars['JSON']['input']>;
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  iosStoreUrl?: InputMaybe<Scalars['String']['input']>;
  maintenanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceEndTime?: InputMaybe<Scalars['String']['input']>;
  maintenanceMessage?: InputMaybe<Scalars['String']['input']>;
  versions?: InputMaybe<AppVersionsInput>;
};

export enum AppContext {
  ClientApp = 'CLIENT_APP',
  HqHero = 'HQ_HERO',
  Portal = 'PORTAL',
  WorkerApp = 'WORKER_APP'
}

export type AppVersionConfig = {
  __typename?: 'AppVersionConfig';
  androidMinimumVersion: Scalars['String']['output'];
  androidRecommendedVersion?: Maybe<Scalars['String']['output']>;
  iosMinimumVersion: Scalars['String']['output'];
  iosRecommendedVersion?: Maybe<Scalars['String']['output']>;
};

export type AppVersionConfigInput = {
  androidMinimumVersion: Scalars['String']['input'];
  androidRecommendedVersion?: InputMaybe<Scalars['String']['input']>;
  iosMinimumVersion: Scalars['String']['input'];
  iosRecommendedVersion?: InputMaybe<Scalars['String']['input']>;
};

export type AppVersions = {
  __typename?: 'AppVersions';
  CLIENT_APP: AppVersionConfig;
  WORKER_APP: AppVersionConfig;
};

export type AppVersionsInput = {
  CLIENT_APP: AppVersionConfigInput;
  WORKER_APP: AppVersionConfigInput;
};

export enum ApplyAcceptMode {
  AcceptOnly = 'ACCEPT_ONLY',
  ApplyOnly = 'APPLY_ONLY',
  Both = 'BOTH'
}

export type Asset = {
  __typename?: 'Asset';
  id: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<AssetStatus>;
  tag: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
  uploadedDate?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum AssetFileType {
  Csv = 'CSV',
  Doc = 'DOC',
  Docx = 'DOCX',
  Heic = 'HEIC',
  Heif = 'HEIF',
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Pdf = 'PDF',
  Png = 'PNG',
  Pptx = 'PPTX',
  Txt = 'TXT',
  Webp = 'WEBP',
  Xls = 'XLS',
  Xlsx = 'XLSX'
}

export enum AssetStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Replaced = 'REPLACED'
}

export type AssetTemplate = {
  __typename?: 'AssetTemplate';
  description: Scalars['String']['output'];
  expiryLength?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  tag: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  usesExpiresAt: Scalars['Boolean']['output'];
  usesIssuedAt: Scalars['Boolean']['output'];
};

export type AssetTemplateInput = {
  description: Scalars['String']['input'];
  expiryLength?: InputMaybe<Scalars['Int']['input']>;
  isRequired: Scalars['Boolean']['input'];
  tag: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  usesExpiresAt: Scalars['Boolean']['input'];
  usesIssuedAt: Scalars['Boolean']['input'];
};

export type AssetTemplateUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  expiryLength?: InputMaybe<Scalars['Int']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  usesExpiresAt?: InputMaybe<Scalars['Boolean']['input']>;
  usesIssuedAt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetUploadInput = {
  fileBytes: Scalars['String']['input'];
  fileType: AssetFileType;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  tag: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum AstuteCustomRateSyncStatus {
  Failed = 'FAILED',
  NotSynced = 'NOT_SYNCED',
  Stale = 'STALE',
  Synced = 'SYNCED'
}

export type AstuteIntegrationCredentialsInput = {
  apiKey: Scalars['String']['input'];
  apiPassword: Scalars['String']['input'];
  apiUsername: Scalars['String']['input'];
  endpointUrl: Scalars['String']['input'];
};

export enum AstuteTimesheetMode {
  OccupationLibrary = 'OCCUPATION_LIBRARY',
  Standard = 'STANDARD'
}

export type AuditLog = {
  __typename?: 'AuditLog';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type Bullhorn_Configuration = {
  __typename?: 'BULLHORN_Configuration';
  polling: Bullhorn_PollingConfig;
  subscriptions: Array<Bullhorn_Subscription>;
  tenantId: Scalars['String']['output'];
};

export type Bullhorn_PollingConfig = {
  __typename?: 'BULLHORN_PollingConfig';
  maxConcurrency: Scalars['Int']['output'];
  maxEventsPerPoll: Scalars['Int']['output'];
  pollIntervalSeconds: Scalars['Int']['output'];
  pollingEnabled: Scalars['Boolean']['output'];
};

export type Bullhorn_Subscription = {
  __typename?: 'BULLHORN_Subscription';
  checkpoint?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  entity: Scalars['String']['output'];
  eventTypes: Array<Bullhorn_SubscriptionEventType>;
  lastPolledAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subscriptionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export enum Bullhorn_SubscriptionEventType {
  Deleted = 'DELETED',
  Inserted = 'INSERTED',
  Updated = 'UPDATED'
}

export type BankDetails = {
  __typename?: 'BankDetails';
  accountFollowingSegment: Scalars['String']['output'];
  accountLeadingSegment: Scalars['String']['output'];
  accountName?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
};

export type BankDetailsInput = {
  accountFollowingSegment: Scalars['String']['input'];
  accountLeadingSegment: Scalars['String']['input'];
  accountName?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
};

export type BlockedUser = {
  __typename?: 'BlockedUser';
  blockedByUserId: Scalars['String']['output'];
  blockedUserRole: UserRole;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerType: BlockedUserOwnerType;
  reason?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export enum BlockedUserOwnerType {
  Client = 'CLIENT',
  Tenant = 'TENANT'
}

export type BreakEvent = {
  __typename?: 'BreakEvent';
  daySequenceId: Scalars['String']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BreakType>;
};

export type BreakEventInput = {
  daySequenceId: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BreakType>;
};

export enum BreakType {
  MealBreak = 'MEAL_BREAK',
  Other = 'OTHER',
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export enum BudgetLimitCategory {
  ActiveClientsPerMonth = 'ACTIVE_CLIENTS_PER_MONTH',
  ActiveWorkersPerMonth = 'ACTIVE_WORKERS_PER_MONTH',
  AiRequestsPerMonth = 'AI_REQUESTS_PER_MONTH',
  JobPostingsPerMonth = 'JOB_POSTINGS_PER_MONTH',
  NotificationsPerMonth = 'NOTIFICATIONS_PER_MONTH'
}

export type BudgetLimits = {
  __typename?: 'BudgetLimits';
  category: BudgetLimitCategory;
  fromDate: Scalars['String']['output'];
  limit: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  resetDate: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type BulkCreateMissingTimesheetInput = {
  breaks: Array<BreakEventInput>;
  clockInTimestamp: Scalars['String']['input'];
  clockOutTimestamp: Scalars['String']['input'];
  dateISO: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};

export type BulkSubmitMissingTimesheetItemResult = {
  __typename?: 'BulkSubmitMissingTimesheetItemResult';
  dateISO: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkSubmitMissingTimesheetsInput = {
  notWorked: Array<MarkMissingTimesheetNotWorkedInput>;
  worked: Array<BulkCreateMissingTimesheetInput>;
};

export type BulkSubmitMissingTimesheetsResult = {
  __typename?: 'BulkSubmitMissingTimesheetsResult';
  attemptedCount: Scalars['Int']['output'];
  results: Array<BulkSubmitMissingTimesheetItemResult>;
  submittedCount: Scalars['Int']['output'];
};

export type BullhornIntegrationCredentialsInput = {
  authToken?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type Card = {
  __typename?: 'Card';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export enum ChargeType {
  Fixed = 'FIXED',
  Margin = 'MARGIN',
  RateCard = 'RATE_CARD'
}

export type ChatMember = {
  __typename?: 'ChatMember';
  addedAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  role: UserRole;
  userId: Scalars['String']['output'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  chatRoomId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  messageAttachmentFilename?: Maybe<Scalars['String']['output']>;
  messageType: ChatMessageType;
  readBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ChatMessagePaginatedResponse = {
  __typename?: 'ChatMessagePaginatedResponse';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  messages: Array<Maybe<ChatMessage>>;
};

export enum ChatMessageType {
  Audio = 'AUDIO',
  File = 'FILE',
  Image = 'IMAGE',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type ChatRoom = {
  __typename?: 'ChatRoom';
  chatType: ChatRoomType;
  createdAt: Scalars['String']['output'];
  createdByUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  members: Array<ChatMember>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum ChatRoomType {
  DirectMessage = 'DIRECT_MESSAGE',
  HqSupportChat = 'HQ_SUPPORT_CHAT',
  JobChat = 'JOB_CHAT',
  SupportChat = 'SUPPORT_CHAT'
}

export type Classification = {
  __typename?: 'Classification';
  classificationGroupId?: Maybe<Scalars['String']['output']>;
  classificationLevels?: Maybe<Array<ClassificationLevel>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ClassificationStatus>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ClassificationAssetMapping = {
  __typename?: 'ClassificationAssetMapping';
  classificationId?: Maybe<Scalars['String']['output']>;
  entries: Array<ClassificationAssetMappingEntry>;
  id?: Maybe<Scalars['String']['output']>;
  pageKey: Scalars['String']['output'];
};

export type ClassificationAssetMappingEntry = {
  __typename?: 'ClassificationAssetMappingEntry';
  key: Scalars['String']['output'];
  overrides?: Maybe<Scalars['JSON']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ClassificationAssetMappingEntryInput = {
  key: Scalars['String']['input'];
  overrides?: InputMaybe<Scalars['JSON']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ClassificationGroup = {
  __typename?: 'ClassificationGroup';
  classifications?: Maybe<Array<Classification>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ClassificationGroupStatus>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ClassificationGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ClassificationGroupStatus>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export enum ClassificationGroupStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ClassificationInput = {
  classificationGroupId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ClassificationStatus>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassificationLevel = {
  __typename?: 'ClassificationLevel';
  classificationId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  minimums?: Maybe<Array<Minimum>>;
  name?: Maybe<Scalars['String']['output']>;
  requiredCompliance?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<ClassificationLevelStatus>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ClassificationLevelClientRate = {
  __typename?: 'ClassificationLevelClientRate';
  classificationLevelId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  minimums?: Maybe<Array<Minimum>>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type ClassificationLevelInput = {
  classificationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  minimums?: InputMaybe<Array<MinimumInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredCompliance?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<ClassificationLevelStatus>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export enum ClassificationLevelStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum ClassificationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type Client = {
  __typename?: 'Client';
  address?: Maybe<Address>;
  addressHash?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Address>;
  businessNumber?: Maybe<Scalars['String']['output']>;
  chargeType?: Maybe<ChargeType>;
  classifications: Array<Classification>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  customAttributes: Array<Maybe<CustomAttribute>>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveRateCard?: Maybe<ClientRateCard>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latLng?: Maybe<LatLng>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  marginOverridePercentage?: Maybe<Scalars['Float']['output']>;
  mergedIntoClientId?: Maybe<Scalars['String']['output']>;
  mergedIntoSiteId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentTerm?: Maybe<Scalars['Int']['output']>;
  primaryContactId?: Maybe<Scalars['String']['output']>;
  rateCard?: Maybe<ClientRateCard>;
  status?: Maybe<ClientStatus>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type ClientInput = {
  address?: InputMaybe<AddressInput>;
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  chargeType?: InputMaybe<ChargeType>;
  classifications?: InputMaybe<Array<Scalars['String']['input']>>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  createSite?: InputMaybe<Scalars['Boolean']['input']>;
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  latLng?: InputMaybe<LatLngInput>;
  marginOverridePercentage?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentTerm?: InputMaybe<Scalars['Int']['input']>;
  primaryContactId?: InputMaybe<Scalars['String']['input']>;
  rateCard?: InputMaybe<ClientRateCardInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type ClientPeriodBill = {
  __typename?: 'ClientPeriodBill';
  clientId: Scalars['String']['output'];
  daySequences: Array<DaySequence>;
  errorSummary: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  periodEndISO: Scalars['String']['output'];
  periodStartISO: Scalars['String']['output'];
  status: ClientPeriodBillStatus;
  tenantId: Scalars['String']['output'];
  totalBillableCents: Scalars['Int']['output'];
};

export enum ClientPeriodBillStatus {
  InvoiceGenerated = 'INVOICE_GENERATED',
  Pending = 'PENDING',
  ReadyForInvoice = 'READY_FOR_INVOICE'
}

export type ClientRateCard = {
  __typename?: 'ClientRateCard';
  bookingFeeCents?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['String']['output']>;
  tiers: Array<ClientRateCardTier>;
};

export type ClientRateCardInput = {
  bookingFeeCents?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['String']['input']>;
  tiers: Array<ClientRateCardTierInput>;
};

export type ClientRateCardTier = {
  __typename?: 'ClientRateCardTier';
  flatCents?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maxDays?: Maybe<Scalars['Int']['output']>;
  minDays: Scalars['Int']['output'];
  perDayCents?: Maybe<Scalars['Int']['output']>;
  type: RateCardTierType;
};

export type ClientRateCardTierInput = {
  flatCents?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  maxDays?: InputMaybe<Scalars['Int']['input']>;
  minDays: Scalars['Int']['input'];
  perDayCents?: InputMaybe<Scalars['Int']['input']>;
  type: RateCardTierType;
};

export enum ClientStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export type ClockEntry = {
  __typename?: 'ClockEntry';
  clockInTimestamp?: Maybe<Scalars['String']['output']>;
  clockOutTimestamp?: Maybe<Scalars['String']['output']>;
};

export type ClockEntryInput = {
  breaks?: InputMaybe<Array<BreakEventInput>>;
  clockInGeo?: InputMaybe<ClockGeoRecordInput>;
  clockInTimestamp?: InputMaybe<Scalars['String']['input']>;
  clockOutGeo?: InputMaybe<ClockGeoRecordInput>;
  clockOutTimestamp?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
};

export type ClockGeoRecord = {
  __typename?: 'ClockGeoRecord';
  accuracyMeters?: Maybe<Scalars['Float']['output']>;
  capturedAt: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type ClockGeoRecordInput = {
  accuracyMeters?: InputMaybe<Scalars['Float']['input']>;
  capturedAt: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type Contract = {
  __typename?: 'Contract';
  agreedAt?: Maybe<Scalars['String']['output']>;
  agreedBy?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  contractTemplateId: Scalars['String']['output'];
  contractType: Scalars['String']['output'];
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isAgreedTo: Scalars['Boolean']['output'];
  ownerId: Scalars['String']['output'];
  pdfUrl: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  validUntil?: Maybe<Scalars['String']['output']>;
};

export type ContractJobStartInput = {
  jobDuration?: InputMaybe<Scalars['Int']['input']>;
  jobDurationUnit?: InputMaybe<TimeUnit>;
  schedule: Array<DailyShiftInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startType: JobStartType;
};

export type ContractStatus = {
  __typename?: 'ContractStatus';
  agreedAt?: Maybe<Scalars['String']['output']>;
  contractDescription: Scalars['String']['output'];
  contractId: Scalars['String']['output'];
  contractTemplateId: Scalars['String']['output'];
  contractType: Scalars['String']['output'];
  isAgreedTo: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  requiresAction: Scalars['Boolean']['output'];
  requiresActionDescription?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  validUntil?: Maybe<Scalars['String']['output']>;
};

export type ContractTemplate = {
  __typename?: 'ContractTemplate';
  contractType: Scalars['String']['output'];
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  pdfUrl: Scalars['String']['output'];
  role: UserRole;
  tenantId: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type CoreLoopConfiguration = {
  __typename?: 'CoreLoopConfiguration';
  configuration?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type CoreLoopConfigurationInput = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  tenantId: Scalars['String']['input'];
};

export type CreateDaySequenceInput = {
  breaks: Array<BreakEventInput>;
  clockInTimestamp: Scalars['String']['input'];
  clockOutTimestamp: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};

export type CreateJobInput = {
  acceptType: JobAcceptType;
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
  classificationId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeInput>>>;
  daysInput: MultiDayInput;
  description: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  marginPercentage?: InputMaybe<Scalars['Float']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  skipNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateMcpApiKeyPayload = {
  __typename?: 'CreateMcpApiKeyPayload';
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CreateNoteInput = {
  /** Free-text note body. Max 500 characters. */
  content: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};

export type CreatePaymentIntentInput = {
  amount: Scalars['Int']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type Credential = {
  __typename?: 'Credential';
  description: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  isSecret?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type CredentialInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CustomAttribute = {
  __typename?: 'CustomAttribute';
  ref: Scalars['String']['output'];
  value: Scalars['String']['output'];
  valueType?: Maybe<CustomAttributeValueType>;
};

export type CustomAttributeConfiguration = {
  __typename?: 'CustomAttributeConfiguration';
  defaultValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentObject: Scalars['String']['output'];
  possibleValues?: Maybe<Array<Scalars['String']['output']>>;
  ref?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributeConfigurationInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentObject?: InputMaybe<Scalars['String']['input']>;
  possibleValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CustomAttributeInput = {
  ref: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum CustomAttributeValueType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Float = 'FLOAT',
  String = 'STRING'
}

export type Customer = {
  __typename?: 'Customer';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type DailyShiftInput = {
  day: DayOfWeek;
  shiftDuration: Scalars['Float']['input'];
  shiftDurationUnit: TimeUnit;
  startTime: Scalars['String']['input'];
};

export type DashboardWorkerOnShiftResponse = {
  __typename?: 'DashboardWorkerOnShiftResponse';
  daySequence?: Maybe<DaySequence>;
  isoDate: Scalars['String']['output'];
  job?: Maybe<Job>;
  user?: Maybe<User>;
};

export type DateRange = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type DayInput = {
  dateTime?: InputMaybe<Scalars['String']['input']>;
  shiftDuration: Scalars['Float']['input'];
  shiftDurationUnit: TimeUnit;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DaySequence = {
  __typename?: 'DaySequence';
  breaks: Array<BreakEvent>;
  clientId?: Maybe<Scalars['String']['output']>;
  clockInByUserId?: Maybe<Scalars['String']['output']>;
  clockInGeo?: Maybe<ClockGeoRecord>;
  clockInTime?: Maybe<Scalars['String']['output']>;
  clockOutByUserId?: Maybe<Scalars['String']['output']>;
  clockOutGeo?: Maybe<ClockGeoRecord>;
  clockOutTime?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  dateTime: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isOpenEnded?: Maybe<Scalars['Boolean']['output']>;
  jobId: Scalars['String']['output'];
  proposedBreaks?: Maybe<Array<BreakEvent>>;
  proposedChangeNotificationSentAt?: Maybe<Scalars['String']['output']>;
  proposedClockInTime?: Maybe<Scalars['String']['output']>;
  proposedClockOutTime?: Maybe<Scalars['String']['output']>;
  shiftDuration: Scalars['Float']['output'];
  shiftDurationUnit: TimeUnit;
  startDate: Scalars['String']['output'];
  startDateISO: Scalars['String']['output'];
  status: DaySequenceStatus;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedByUserId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type DaySequenceChangeInput = {
  clockInTimestamp: Scalars['String']['input'];
  clockOutTimestamp: Scalars['String']['input'];
  id: Scalars['String']['input'];
  proposedBreaks: Array<BreakEventInput>;
};

export enum DaySequenceStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  ErrorEncountered = 'ERROR_ENCOUNTERED',
  EscalatedToTenant = 'ESCALATED_TO_TENANT',
  InProgress = 'IN_PROGRESS',
  ManualInterventionRequired = 'MANUAL_INTERVENTION_REQUIRED',
  NotWorked = 'NOT_WORKED',
  PayProcessed = 'PAY_PROCESSED',
  Pending = 'PENDING',
  ProposedChange = 'PROPOSED_CHANGE',
  ReadyForPay = 'READY_FOR_PAY',
  RequiresApproval = 'REQUIRES_APPROVAL',
  Unfilled = 'UNFILLED'
}

export type DayToDayJobStartInput = {
  daysInput?: InputMaybe<Array<DayInput>>;
  startType: JobStartType;
};

export type DeletePaymentMethodResponse = {
  __typename?: 'DeletePaymentMethodResponse';
  paymentMethod: PaymentMethod;
  success: Scalars['Boolean']['output'];
};

export enum DraftJobState {
  Created = 'CREATED',
  Discarded = 'DISCARDED',
  Error = 'ERROR',
  MissingInformation = 'MISSING_INFORMATION',
  PendingApprovalByClient = 'PENDING_APPROVAL_BY_CLIENT',
  PendingCreation = 'PENDING_CREATION',
  Posted = 'POSTED',
  ReadyToPost = 'READY_TO_POST',
  Rejected = 'REJECTED',
  ShouldPostNextChance = 'SHOULD_POST_NEXT_CHANCE'
}

export type DuplicateSiteGroup = {
  __typename?: 'DuplicateSiteGroup';
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  normalisedAddress: Scalars['String']['output'];
  sites: Array<DuplicateSitePrecheckSite>;
};

export type DuplicateSitePrecheckSite = {
  __typename?: 'DuplicateSitePrecheckSite';
  address?: Maybe<Address>;
  id: Scalars['String']['output'];
  integrationReferences: Array<AbsorbClientIntegrationReference>;
  jobCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pendingInviteCount: Scalars['Int']['output'];
  status?: Maybe<SiteStatus>;
  userCount: Scalars['Int']['output'];
};

export type DuplicateSitesPrecheck = {
  __typename?: 'DuplicateSitesPrecheck';
  duplicateGroupCount: Scalars['Int']['output'];
  groups: Array<DuplicateSiteGroup>;
  scannedClientCount: Scalars['Int']['output'];
  scannedSiteCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

export enum External_FindableObject {
  Client = 'CLIENT',
  DaySequence = 'DAY_SEQUENCE',
  Job = 'JOB',
  User = 'USER'
}

export type EditNoteInput = {
  /** Free-text note body. Max 500 characters. */
  content: Scalars['String']['input'];
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  htmlContent: Scalars['String']['output'];
  id: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  type: EmailTemplateType;
  variables: Array<Maybe<Scalars['String']['output']>>;
};

export enum EmailTemplateType {
  AccountApprovedUser = 'ACCOUNT_APPROVED_USER',
  ClientInvoice = 'CLIENT_INVOICE',
  ClientPostedJobTenant = 'CLIENT_POSTED_JOB_TENANT',
  DeferredActionComplete = 'DEFERRED_ACTION_COMPLETE',
  InviteClient = 'INVITE_CLIENT',
  InviteTenant = 'INVITE_TENANT',
  InviteWorker = 'INVITE_WORKER',
  JobAcceptedClient = 'JOB_ACCEPTED_CLIENT',
  JobAcceptedWorker = 'JOB_ACCEPTED_WORKER',
  JobApplicationApprovedClient = 'JOB_APPLICATION_APPROVED_CLIENT',
  JobApplicationApprovedWorker = 'JOB_APPLICATION_APPROVED_WORKER',
  JobApplicationClient = 'JOB_APPLICATION_CLIENT',
  JobApplicationRejectedWorker = 'JOB_APPLICATION_REJECTED_WORKER',
  JobAssignedClient = 'JOB_ASSIGNED_CLIENT',
  JobAssignedWorker = 'JOB_ASSIGNED_WORKER',
  JobAvailableWorker = 'JOB_AVAILABLE_WORKER',
  JobCancelledClient = 'JOB_CANCELLED_CLIENT',
  JobCancelledWorker = 'JOB_CANCELLED_WORKER',
  JobCompletedClient = 'JOB_COMPLETED_CLIENT',
  JobFilledClient = 'JOB_FILLED_CLIENT',
  JobUnassignedWorker = 'JOB_UNASSIGNED_WORKER',
  JobWithdrawnClient = 'JOB_WITHDRAWN_CLIENT',
  JobWithdrawnWorker = 'JOB_WITHDRAWN_WORKER',
  PasswordReset = 'PASSWORD_RESET',
  TemporaryPasswordClient = 'TEMPORARY_PASSWORD_CLIENT',
  TemporaryPasswordTenant = 'TEMPORARY_PASSWORD_TENANT',
  TemporaryPasswordWorker = 'TEMPORARY_PASSWORD_WORKER',
  TimesheetApprovalReminder = 'TIMESHEET_APPROVAL_REMINDER'
}

export type EmploymentDetails = {
  __typename?: 'EmploymentDetails';
  costCenter?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  payGroup?: Maybe<Scalars['String']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  workLocation?: Maybe<Scalars['String']['output']>;
};

export type EmploymentDetailsInput = {
  costCenter?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  payGroup?: InputMaybe<Scalars['String']['input']>;
  payrollId?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalReference = {
  __typename?: 'ExternalReference';
  compositeArrayValue?: Maybe<Array<Scalars['String']['output']>>;
  compositeObjectValue?: Maybe<Scalars['JSON']['output']>;
  key: Scalars['String']['output'];
  primativeValue?: Maybe<Scalars['String']['output']>;
  rawValue: Scalars['JSON']['output'];
  valueType: ExternalReferenceValueType;
};

export enum ExternalReferenceValueType {
  CompositeArray = 'COMPOSITE_ARRAY',
  CompositeObject = 'COMPOSITE_OBJECT',
  Primitive = 'PRIMITIVE'
}

export type FcmToken = {
  __typename?: 'FCMToken';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<FcmTokenMetadata>;
  token: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type FcmTokenMetadata = {
  __typename?: 'FCMTokenMetadata';
  appVersion?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
};

export type FcmTokenMetadataInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

export type FavouriteUser = {
  __typename?: 'FavouriteUser';
  clientId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type HubspotIntegrationCredentialsInput = {
  apiKey: Scalars['String']['input'];
};

export type Importer = {
  __typename?: 'Importer';
  actions: Array<Maybe<ImporterAction>>;
  customAttributes: Array<Maybe<ImporterAttribute>>;
  description: Scalars['String']['output'];
  directAttributes: Array<Maybe<ImporterAttribute>>;
  externalAttributes: Array<Maybe<ImporterAttribute>>;
  externalReferences: Array<Maybe<ImporterAttribute>>;
  name: Scalars['String']['output'];
  objectType: ObjectType;
};

export type ImporterAction = {
  __typename?: 'ImporterAction';
  actionObjectId: Scalars['String']['output'];
  actionType: ImporterActionType;
};

export enum ImporterActionType {
  AddClassificationLevelToUser = 'ADD_CLASSIFICATION_LEVEL_TO_USER'
}

export type ImporterAttribute = {
  __typename?: 'ImporterAttribute';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: ImporterAttributeType;
};

export enum ImporterAttributeType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  Object = 'OBJECT',
  String = 'STRING'
}

export type ImporterInput = {
  data: Array<InputMaybe<Scalars['JSON']['input']>>;
  objectType: ObjectType;
  options: Array<InputMaybe<ImporterOption>>;
  tenantId: Scalars['String']['input'];
};

export enum ImporterOption {
  DryRun = 'DRY_RUN',
  SendEmailOnComplete = 'SEND_EMAIL_ON_COMPLETE',
  SendInvites = 'SEND_INVITES',
  StopOnError = 'STOP_ON_ERROR',
  TreatDuplicateAsError = 'TREAT_DUPLICATE_AS_ERROR',
  TreatWarningsAsErrors = 'TREAT_WARNINGS_AS_ERRORS',
  Upsert = 'UPSERT',
  Verbose = 'VERBOSE'
}

export type InboxItem = {
  __typename?: 'InboxItem';
  actionLink?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerType: ObjectType;
  readAt?: Maybe<Scalars['String']['output']>;
  relevantObjectId?: Maybe<Scalars['String']['output']>;
  relevantObjectType?: Maybe<ObjectType>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InfoPanel = {
  __typename?: 'InfoPanel';
  paragraphs: Array<InfoPanelParagraph>;
  title: Scalars['String']['output'];
};

export type InfoPanelInput = {
  paragraphs: Array<InfoPanelParagraphInput>;
  title: Scalars['String']['input'];
};

export type InfoPanelParagraph = {
  __typename?: 'InfoPanelParagraph';
  bulletPoints: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type InfoPanelParagraphInput = {
  bulletPoints: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type InitiatePayRunForTenantRequest = {
  __typename?: 'InitiatePayRunForTenantRequest';
  id: Scalars['String']['output'];
  status: InitiatePayRunForTenantStatus;
};

export enum InitiatePayRunForTenantStatus {
  Queued = 'QUEUED'
}

export type Integration = {
  __typename?: 'Integration';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  requiresCredentials: Array<Maybe<Credential>>;
};

export type IntegrationConfigurationOption = {
  __typename?: 'IntegrationConfigurationOption';
  action?: Maybe<IntegrationConfigurationOptionAction>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  showInUiIf?: Maybe<IntegrationConfigurationOptionVisibility>;
  values: Array<IntegrationConfigurationValue>;
};

export type IntegrationConfigurationOptionAction = {
  __typename?: 'IntegrationConfigurationOptionAction';
  description?: Maybe<Scalars['String']['output']>;
  input?: Maybe<IntegrationConfigurationOptionActionInput>;
  mutationName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type IntegrationConfigurationOptionActionInput = {
  __typename?: 'IntegrationConfigurationOptionActionInput';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type IntegrationConfigurationOptionVisibility = {
  __typename?: 'IntegrationConfigurationOptionVisibility';
  alwaysShow?: Maybe<Scalars['Boolean']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
};

export type IntegrationConfigurationValue = {
  __typename?: 'IntegrationConfigurationValue';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type IntegrationConnection = {
  __typename?: 'IntegrationConnection';
  credentials: Array<Maybe<StoredCredential>>;
  customAttributes: Scalars['JSON']['output'];
  externalAttributes: Scalars['JSON']['output'];
  externalReferences: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  integrationEnabled?: Maybe<Scalars['Boolean']['output']>;
  integrationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type IntegrationConnectionAttributeInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type IntegrationCredentialTemplate = {
  __typename?: 'IntegrationCredentialTemplate';
  description: Scalars['String']['output'];
  isSecret?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
};

export enum IntegrationDataDirection {
  BiDirectional = 'BI_DIRECTIONAL',
  Pull = 'PULL',
  Push = 'PUSH'
}

export type IntegrationDataFlow = {
  __typename?: 'IntegrationDataFlow';
  description: Scalars['String']['output'];
  direction: IntegrationDataDirection;
};

export enum IntegrationEnvironment {
  Production = 'PRODUCTION',
  Sandbox = 'SANDBOX'
}

export type IntegrationEnvironmentConfig = {
  __typename?: 'IntegrationEnvironmentConfig';
  apiBaseUrl?: Maybe<Scalars['String']['output']>;
  environment: IntegrationEnvironment;
  notes?: Maybe<Scalars['String']['output']>;
  portalUrl?: Maybe<Scalars['String']['output']>;
};

export type IntegrationInitializationReference = {
  __typename?: 'IntegrationInitializationReference';
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type IntegrationInitializationSchema = {
  __typename?: 'IntegrationInitializationSchema';
  apiDocsUrls?: Maybe<Array<Scalars['String']['output']>>;
  businessSummary?: Maybe<Scalars['String']['output']>;
  configurationOptions: Array<IntegrationConfigurationOption>;
  credentialOwnerRole?: Maybe<Scalars['String']['output']>;
  credentialTemplates: Array<IntegrationCredentialTemplate>;
  customerPrerequisites?: Maybe<Array<Scalars['String']['output']>>;
  dataFlows?: Maybe<Array<IntegrationDataFlow>>;
  defaultEnvironment?: Maybe<IntegrationEnvironment>;
  description: Scalars['String']['output'];
  devNotes?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  environments: Array<IntegrationEnvironmentConfig>;
  integrationId: Scalars['String']['output'];
  integrationType: IntegrationType;
  logoUrl?: Maybe<Scalars['String']['output']>;
  maxConnectionsPerTenant?: Maybe<Scalars['Int']['output']>;
  ongoingMaintenanceNotes?: Maybe<Array<Scalars['String']['output']>>;
  openItems: Array<Scalars['String']['output']>;
  operationalNotes: Array<Scalars['String']['output']>;
  platform: SupportedIntegrationPlatform;
  portalUrls?: Maybe<Array<Scalars['String']['output']>>;
  primaryUseCases?: Maybe<Array<Scalars['String']['output']>>;
  recommendedTestingSteps?: Maybe<Array<Scalars['String']['output']>>;
  references: Array<IntegrationInitializationReference>;
  scopeCovered: Array<Scalars['String']['output']>;
  setupSteps: Array<IntegrationSetupStep>;
  singleConnectionPerTenant: Scalars['Boolean']['output'];
  supportUrls?: Maybe<Array<Scalars['String']['output']>>;
  supportsAtsExplorer: Scalars['Boolean']['output'];
  unsupported: Array<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type IntegrationSetupStep = {
  __typename?: 'IntegrationSetupStep';
  description?: Maybe<Scalars['String']['output']>;
  resources?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
};

export enum IntegrationType {
  Ats = 'ATS',
  Other = 'Other',
  Payroll = 'Payroll'
}

export type Invite = {
  __typename?: 'Invite';
  clientId?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inviteLink: Scalars['String']['output'];
  inviteSentAt?: Maybe<Scalars['String']['output']>;
  invitingUserId: Scalars['String']['output'];
  invitingUserRole: UserRole;
  itemStatus: InviteStatus;
  siteIds?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userRole: UserRole;
};

export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  InviteSent = 'INVITE_SENT',
  PendingSend = 'PENDING_SEND'
}

export type Invoice = {
  __typename?: 'Invoice';
  clientId: Scalars['String']['output'];
  clientPeriodBillIds: Array<Scalars['String']['output']>;
  clientPeriodBills: Array<ClientPeriodBill>;
  createdAt: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceItems: Array<InvoiceItem>;
  invoiceKey?: Maybe<Scalars['String']['output']>;
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  itemStatus: InvoiceStatus;
  sentAt?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalAmountInCents: Scalars['Int']['output'];
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  billableHourlyRateInCents: Scalars['Int']['output'];
  clientId: Scalars['String']['output'];
  daySequence?: Maybe<DaySequence>;
  daySequenceId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hoursWorked: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  invoice?: Maybe<Invoice>;
  invoiceId: Scalars['String']['output'];
  job?: Maybe<Job>;
  jobId: Scalars['String']['output'];
  siteId?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalAmountInCents: Scalars['Int']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export enum InvoiceStatus {
  Any = 'ANY',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  DryRun = 'DRY_RUN',
  NoInvoiceRequiredYet = 'NO_INVOICE_REQUIRED_YET',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export enum ItemStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Any = 'ANY',
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
  JobFinished = 'JOB_FINISHED',
  Unfilled = 'UNFILLED'
}

export type Jobadder_InboundImportEntityPolicy = {
  __typename?: 'JOBADDER_InboundImportEntityPolicy';
  allowed: Scalars['Boolean']['output'];
  effectiveAllowed: Scalars['Boolean']['output'];
  effectiveIncludeLinkedItems: Scalars['Boolean']['output'];
  includeLinkedItems: Scalars['Boolean']['output'];
};

export type Jobadder_InboundImportEntityPolicyInput = {
  allowed?: InputMaybe<Scalars['Boolean']['input']>;
  includeLinkedItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Jobadder_InboundImportPolicy = {
  __typename?: 'JOBADDER_InboundImportPolicy';
  allowAllIncoming: Scalars['Boolean']['output'];
  applications: Jobadder_InboundImportEntityPolicy;
  attemptToMatchJobClassificationFromAssignedWorker: Scalars['Boolean']['output'];
  clients: Jobadder_InboundImportEntityPolicy;
  contacts: Jobadder_InboundImportEntityPolicy;
  description: Scalars['String']['output'];
  globalInboundUpsertAllowed: Scalars['Boolean']['output'];
  jobs: Jobadder_InboundImportEntityPolicy;
  placements: Jobadder_InboundImportEntityPolicy;
  tenantId: Scalars['String']['output'];
  workers: Jobadder_InboundImportEntityPolicy;
};

export type Jobadder_InboundImportPolicyInput = {
  allowAllIncoming?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<Jobadder_InboundImportEntityPolicyInput>;
  attemptToMatchJobClassificationFromAssignedWorker?: InputMaybe<Scalars['Boolean']['input']>;
  clients?: InputMaybe<Jobadder_InboundImportEntityPolicyInput>;
  contacts?: InputMaybe<Jobadder_InboundImportEntityPolicyInput>;
  jobs?: InputMaybe<Jobadder_InboundImportEntityPolicyInput>;
  placements?: InputMaybe<Jobadder_InboundImportEntityPolicyInput>;
  workers?: InputMaybe<Jobadder_InboundImportEntityPolicyInput>;
};

export enum Jobadder_PlacementImportOutcome {
  Failed = 'FAILED',
  Imported = 'IMPORTED',
  Upserted = 'UPSERTED'
}

export type Jobadder_PlacementImportPayload = {
  __typename?: 'JOBADDER_PlacementImportPayload';
  results: Array<Jobadder_PlacementImportResult>;
};

export type Jobadder_PlacementImportResult = {
  __typename?: 'JOBADDER_PlacementImportResult';
  imported: Scalars['Boolean']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  outcome: Jobadder_PlacementImportOutcome;
  placementId: Scalars['String']['output'];
};

export type Job = {
  __typename?: 'Job';
  additionalNotes?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  addressHash?: Maybe<Scalars['String']['output']>;
  allowQuotes?: Maybe<Scalars['Boolean']['output']>;
  applicationCount?: Maybe<Scalars['Int']['output']>;
  applicationCountsByStatus?: Maybe<Array<JobApplicationStatusCount>>;
  applicationsCloseAt?: Maybe<Scalars['String']['output']>;
  astuteCustomRateSyncError?: Maybe<Scalars['String']['output']>;
  astuteCustomRateSyncStatus?: Maybe<AstuteCustomRateSyncStatus>;
  astuteCustomRateSyncedAt?: Maybe<Scalars['String']['output']>;
  astuteOccupationLibraryOid?: Maybe<Scalars['String']['output']>;
  budget?: Maybe<Scalars['Int']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['String']['output']>;
  cancelledByUserId?: Maybe<Scalars['String']['output']>;
  cancelledWhileFilledWorkerId?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Classification>;
  classificationId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clockInTime?: Maybe<Scalars['String']['output']>;
  clockOutTime?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttribute>>>;
  daySequence?: Maybe<Array<DaySequence>>;
  days?: Maybe<JobDays>;
  description?: Maybe<Scalars['String']['output']>;
  durationInDays?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  filledAt?: Maybe<Scalars['String']['output']>;
  finalClientPayRateCents?: Maybe<Scalars['Int']['output']>;
  finalWorkerPayRateCents?: Maybe<Scalars['Int']['output']>;
  frequency?: Maybe<JobFrequency>;
  hasCustomPayRates?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  itemStatus?: Maybe<JobStatus>;
  latLng?: Maybe<LatLng>;
  marginPercentage?: Maybe<Scalars['Float']['output']>;
  paidBreakDurationMinutes?: Maybe<Scalars['Float']['output']>;
  parentId: Scalars['String']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  postedBy?: Maybe<User>;
  potentialPayRates?: Maybe<PotentialPayRates>;
  previousDays?: Maybe<JobDays>;
  previousEndDate?: Maybe<Scalars['String']['output']>;
  previousScheduleEndDate?: Maybe<Scalars['String']['output']>;
  previousScheduleStartDate?: Maybe<Scalars['String']['output']>;
  previousStartDate?: Maybe<Scalars['String']['output']>;
  scheduleEndDate?: Maybe<Scalars['String']['output']>;
  scheduleStartDate?: Maybe<Scalars['String']['output']>;
  shiftDurationMinutes?: Maybe<Scalars['Float']['output']>;
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['String']['output']>;
  startAfterDate?: Maybe<Scalars['String']['output']>;
  startBeforeDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startType?: Maybe<JobStartType>;
  tenantId: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  unpaidBreakDurationMinutes?: Maybe<Scalars['Float']['output']>;
  userAcceptedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  workType?: Maybe<Scalars['String']['output']>;
  workersShouldApplyToJob?: Maybe<Scalars['Boolean']['output']>;
};

export enum JobAcceptType {
  Accept = 'ACCEPT',
  Apply = 'APPLY'
}

export type JobAdderIntegrationCredentialsInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type JobApplication = {
  __typename?: 'JobApplication';
  classificationLevel?: Maybe<ClassificationLevel>;
  clientId: Scalars['String']['output'];
  clientRateInCents?: Maybe<Scalars['Int']['output']>;
  coverLetter?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemStatus?: Maybe<JobApplicationStatus>;
  jobId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  workerRateInCents?: Maybe<Scalars['Int']['output']>;
};

export enum JobApplicationStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Withdrawn = 'WITHDRAWN'
}

export type JobApplicationStatusCount = {
  __typename?: 'JobApplicationStatusCount';
  count: Scalars['Int']['output'];
  status: JobApplicationStatus;
};

export type JobDays = {
  __typename?: 'JobDays';
  days: Array<Maybe<DayOfWeek>>;
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export enum JobFrequency {
  Daily = 'DAILY',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Other = 'OTHER',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum JobStartType {
  Asap = 'ASAP',
  Flexible = 'FLEXIBLE',
  StartAfter = 'START_AFTER',
  StartOn = 'START_ON'
}

export enum JobStatus {
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Filled = 'FILLED',
  Unfilled = 'UNFILLED'
}

export type KeypayIntegrationCredentialsInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
};

export type LatLng = {
  __typename?: 'LatLng';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type LatLngInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type List = {
  __typename?: 'List';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  items?: Maybe<Array<ListItem>>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['String']['output'];
  ownerObjectType: ObjectType;
  targetObjectType: ObjectType;
  tenantId: Scalars['String']['output'];
};

export type ListInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  ownerObjectType?: InputMaybe<ObjectType>;
  targetObjectType?: InputMaybe<ObjectType>;
  tenantId: Scalars['String']['input'];
};

export type ListItem = {
  __typename?: 'ListItem';
  id: Scalars['String']['output'];
  listId: Scalars['String']['output'];
  targetObjectId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type ListItemInput = {
  targetObjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type MarkMissingTimesheetNotWorkedInput = {
  dateISO: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};

export type McpApiKey = {
  __typename?: 'McpApiKey';
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type McpOAuthConnectionInfo = {
  __typename?: 'McpOAuthConnectionInfo';
  authorizationServer: Scalars['String']['output'];
  authorizationUrl: Scalars['String']['output'];
  protectedResourceMetadata: Scalars['String']['output'];
  registrationEndpoint: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  scopes: Array<Scalars['String']['output']>;
  tokenEndpoint: Scalars['String']['output'];
};

export type McpOAuthSession = {
  __typename?: 'McpOAuthSession';
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  vendor?: Maybe<Scalars['String']['output']>;
};

export type McpQueryLog = {
  __typename?: 'McpQueryLog';
  apiKeyId?: Maybe<Scalars['String']['output']>;
  args: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  conversationSnippet?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  queryText?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  toolName: Scalars['String']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type McpQueryLogPaginatedResult = {
  __typename?: 'McpQueryLogPaginatedResult';
  hasMore: Scalars['Boolean']['output'];
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  logs: Array<McpQueryLog>;
};

export type MergeClientsBlocker = {
  __typename?: 'MergeClientsBlocker';
  alignToClientId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  currentValue?: Maybe<Scalars['String']['output']>;
  daySequenceId?: Maybe<Scalars['String']['output']>;
  expectedValue?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  jobStatus?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  kind: MergeClientsBlockerKind;
  message: Scalars['String']['output'];
  suggestedAction: MergeClientsSuggestedAction;
};

export enum MergeClientsBlockerKind {
  ActiveJob = 'ACTIVE_JOB',
  AlreadyMerged = 'ALREADY_MERGED',
  ClassificationLevelRates = 'CLASSIFICATION_LEVEL_RATES',
  ClientNotFound = 'CLIENT_NOT_FOUND',
  CommercialConflict = 'COMMERCIAL_CONFLICT',
  CrossTenant = 'CROSS_TENANT',
  DuplicateClient = 'DUPLICATE_CLIENT',
  InsufficientClients = 'INSUFFICIENT_CLIENTS',
  MultiLocationSites = 'MULTI_LOCATION_SITES',
  OpenDaySequence = 'OPEN_DAY_SEQUENCE'
}

export type MergeClientsPrecheck = {
  __typename?: 'MergeClientsPrecheck';
  blockers: Array<MergeClientsBlocker>;
  blockingReasons: Array<Scalars['String']['output']>;
  canMerge: Scalars['Boolean']['output'];
  proposedChargeType?: Maybe<ChargeType>;
  proposedClassificationIds: Array<Scalars['String']['output']>;
  proposedMarginOverridePercentage?: Maybe<Scalars['Float']['output']>;
  proposedPaymentTerm?: Maybe<Scalars['Int']['output']>;
  proposedSiteNames: Array<Scalars['String']['output']>;
  sources: Array<MergeClientsPrecheckSource>;
};

export type MergeClientsPrecheckJob = {
  __typename?: 'MergeClientsPrecheckJob';
  id: Scalars['String']['output'];
  status?: Maybe<JobStatus>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MergeClientsPrecheckSource = {
  __typename?: 'MergeClientsPrecheckSource';
  blockedUserCount: Scalars['Int']['output'];
  blockingActiveJobCount: Scalars['Int']['output'];
  blockingActiveJobs: Array<MergeClientsPrecheckJob>;
  chargeType?: Maybe<ChargeType>;
  classificationIds: Array<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  favouriteCount: Scalars['Int']['output'];
  hasClassificationLevelClientRates: Scalars['Boolean']['output'];
  invoiceCount: Scalars['Int']['output'];
  marginOverridePercentage?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  openDaySequenceCount: Scalars['Int']['output'];
  outstandingInviteCount: Scalars['Int']['output'];
  paymentTerm?: Maybe<Scalars['Int']['output']>;
  periodBillCount: Scalars['Int']['output'];
  siteCount: Scalars['Int']['output'];
  status?: Maybe<ClientStatus>;
  terminalJobsLeftAsIsCount: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
  users: Array<MergeClientsPrecheckUser>;
};

export type MergeClientsPrecheckUser = {
  __typename?: 'MergeClientsPrecheckUser';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export enum MergeClientsSuggestedAction {
  AlignChargeType = 'ALIGN_CHARGE_TYPE',
  AlignMargin = 'ALIGN_MARGIN',
  AlignPaymentTerm = 'ALIGN_PAYMENT_TERM',
  AlignRateCard = 'ALIGN_RATE_CARD',
  CancelJob = 'CANCEL_JOB',
  None = 'NONE',
  ResolveDaySequence = 'RESOLVE_DAY_SEQUENCE'
}

export type Minimum = {
  __typename?: 'Minimum';
  countryHash?: Maybe<Scalars['String']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
};

export type MinimumInput = {
  countryHash?: InputMaybe<Scalars['String']['input']>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
};

export type MissingTimesheet = {
  __typename?: 'MissingTimesheet';
  clientId: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  scheduledEndTime?: Maybe<Scalars['String']['output']>;
  scheduledStartTime?: Maybe<Scalars['String']['output']>;
  shiftDate: Scalars['String']['output'];
  siteId?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  workType?: Maybe<Scalars['String']['output']>;
  workerName?: Maybe<Scalars['String']['output']>;
  workerProfileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type MissingTimesheetsResult = {
  __typename?: 'MissingTimesheetsResult';
  items: Array<MissingTimesheet>;
};

export type MultiDayInput = {
  days?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  ASTUTE_ensurePayRunPreCheck: Astute_PayRunPreCheck;
  ASTUTE_forceEnsureClient?: Maybe<Scalars['Boolean']['output']>;
  ASTUTE_forceEnsureJob?: Maybe<Scalars['Boolean']['output']>;
  ASTUTE_pinOccupationLibraryToClassificationLevel?: Maybe<Scalars['Boolean']['output']>;
  ASTUTE_runPayRunPreCheck: Astute_PayRunPreCheck;
  ASTUTE_setClientBiller: Astute_ClientBiller;
  ASTUTE_setIdentifierPolicy: Astute_IdentifierPolicy;
  ASTUTE_syncJobAssignment: Job;
  BULLHORN_setPollingConfig?: Maybe<Scalars['Boolean']['output']>;
  JOBADDER_importPlacements: Jobadder_PlacementImportPayload;
  JOBADDER_setAuth?: Maybe<Scalars['Boolean']['output']>;
  JOBADDER_setInboundImportPolicy: Jobadder_InboundImportPolicy;
  VEVO_forceCheckUser?: Maybe<Scalars['Boolean']['output']>;
  absorbClient: AbsorbClientResult;
  absorbSite: AbsorbSiteResult;
  acceptJob?: Maybe<Job>;
  addClassificationToClient?: Maybe<Client>;
  addFavouriteUser?: Maybe<Scalars['Boolean']['output']>;
  addIntegrationConnectionToTenant?: Maybe<IntegrationConnection>;
  addItemsToList: List;
  addQuestionToMasterList?: Maybe<OnboardingQuestion>;
  addQuestionToParentQuestion?: Maybe<OnboardingQuestion>;
  addRequirementToTenant: Template;
  agreeToContract?: Maybe<Contract>;
  agreeToPolicy: Policy;
  applyForJob?: Maybe<JobApplication>;
  approveDaySequences?: Maybe<Array<Maybe<DaySequence>>>;
  archiveChatRoom: Scalars['Boolean']['output'];
  assignClassificationLevelToUser: User;
  assignRecruiterToWorker?: Maybe<Scalars['Boolean']['output']>;
  assignUser?: Maybe<Scalars['Boolean']['output']>;
  blockUser: BlockedUser;
  bulkClockActions?: Maybe<Array<Maybe<DaySequence>>>;
  bulkSubmitMissingTimesheets: BulkSubmitMissingTimesheetsResult;
  cancelJob?: Maybe<Scalars['Boolean']['output']>;
  clearClientRateCardOverride?: Maybe<Client>;
  clearUserFCMToken: Scalars['Boolean']['output'];
  clockAction?: Maybe<DaySequence>;
  clockIn?: Maybe<DaySequence>;
  clockOut?: Maybe<DaySequence>;
  createAssetTemplate?: Maybe<AssetTemplate>;
  createAuditLog: AuditLog;
  createChatRoom: ChatRoom;
  createClassification?: Maybe<Classification>;
  createClassificationAssetMapping?: Maybe<ClassificationAssetMapping>;
  createClassificationGroup: ClassificationGroup;
  createClassificationLevel?: Maybe<ClassificationLevel>;
  createClient?: Maybe<Client>;
  createContractTemplate?: Maybe<ContractTemplate>;
  createCustomAttributeConfiguration: CustomAttributeConfiguration;
  createDaySequences?: Maybe<Array<DaySequence>>;
  createHqSupportChat: ChatRoom;
  createJob: Job;
  createList: List;
  createMcpApiKey: CreateMcpApiKeyPayload;
  /** Creates a note attached to an object. */
  createNote: Note;
  /**
   * Creates a new onboarding template version from an existing template.
   * Archives the previous active template for that tenant and role.
   * Blocked until the tenant onboarding version backfill has completed.
   */
  createOnboardingTemplateVersion?: Maybe<OnboardingTemplate>;
  createPaymentIntent: PaymentIntent;
  createPolicyTemplate: PolicyTemplate;
  createReview: Review;
  createSetupIntent: SetupIntent;
  createSite: Site;
  createSmartList: SmartList;
  createSupportChat: ChatRoom;
  createTenant?: Maybe<Tenant>;
  /** Create a tenant-owned onboarding question (not a master catalogue row). */
  createTenantOnboardingQuestion?: Maybe<OnboardingQuestion>;
  createUser?: Maybe<User>;
  deleteAllInboxItems: Scalars['Boolean']['output'];
  deleteAsset?: Maybe<Scalars['Boolean']['output']>;
  deleteAssetTemplate?: Maybe<Scalars['Boolean']['output']>;
  deleteClassification?: Maybe<Scalars['Boolean']['output']>;
  deleteClassificationAssetMapping?: Maybe<Scalars['Boolean']['output']>;
  deleteClassificationGroup?: Maybe<Scalars['Boolean']['output']>;
  deleteClassificationLevel?: Maybe<Scalars['Boolean']['output']>;
  deleteClient?: Maybe<Scalars['Boolean']['output']>;
  deleteCustomAttributeConfiguration?: Maybe<Scalars['Boolean']['output']>;
  deleteDaySequences: Array<Scalars['String']['output']>;
  deleteInboxItem: Scalars['Boolean']['output'];
  deleteIntegrationConnection?: Maybe<Scalars['Boolean']['output']>;
  deleteJob?: Maybe<Scalars['Boolean']['output']>;
  deleteList: Scalars['Boolean']['output'];
  /** Deletes an existing note. */
  deleteNote: Scalars['Boolean']['output'];
  deletePaymentMethod: DeletePaymentMethodResponse;
  deletePolicyTemplate: Scalars['Boolean']['output'];
  deleteReview: Scalars['Boolean']['output'];
  deleteSite?: Maybe<Scalars['Boolean']['output']>;
  deleteSmartList: Scalars['Boolean']['output'];
  deleteTenant?: Maybe<Scalars['Boolean']['output']>;
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  disableMaintenance: AppConfig;
  /**
   * Dismisses the rating prompt without stars. All eligible pending jobs for that
   * worker are marked DISMISSED so older shifts do not reappear.
   */
  dismissJobRating: Review;
  disputeDaySequences?: Maybe<Array<Maybe<DaySequence>>>;
  /** Updates the content of an existing note. */
  editNote: Note;
  editReview: Review;
  enableIntegrationConnection?: Maybe<Scalars['Boolean']['output']>;
  enableMaintenance: AppConfig;
  escalateChatRoom: ChatRoom;
  excludeJobFromReliabilityScore: Scalars['Boolean']['output'];
  forceSyncPartialPayRunCycleLog: Scalars['Boolean']['output'];
  forceSyncPayRunCycleLog: Scalars['Boolean']['output'];
  generateInvoices: Array<Invoice>;
  importClassificationMapping?: Maybe<Scalars['Boolean']['output']>;
  importData: Scalars['Boolean']['output'];
  importStatusMapping?: Maybe<Scalars['Boolean']['output']>;
  initiatePayRunForTenant: InitiatePayRunForTenantRequest;
  initiateUserSelfDeletion?: Maybe<Scalars['Boolean']['output']>;
  inviteUser?: Maybe<Scalars['Boolean']['output']>;
  jobAdderConsumeAuthCode?: Maybe<Scalars['Boolean']['output']>;
  jobAdderRefreshAccessToken?: Maybe<Scalars['Boolean']['output']>;
  joinChatRoom: ChatRoom;
  linkQuestionToParentQuestion?: Maybe<OnboardingQuestion>;
  markAllInboxItemsAsRead: Scalars['Boolean']['output'];
  markDaySequenceNotWorked: DaySequence;
  markInboxItemAsRead: Scalars['Boolean']['output'];
  mergeClients: Client;
  normaliseClientAndSiteAddresses: Scalars['Boolean']['output'];
  processPartialUpdates: PartialUpdateResult;
  proposeDaySequenceChanges?: Maybe<Array<Maybe<DaySequence>>>;
  removeClassificationFromClient?: Maybe<Client>;
  removeClassificationLevelFromUser: User;
  removeFavouriteUser?: Maybe<Scalars['Boolean']['output']>;
  removeItemsFromList: List;
  removeRequirementFromTenant: Template;
  reorderChildQuestionsForParentQuestion?: Maybe<OnboardingQuestion>;
  requestPredictiveShiftReportExport: PredictiveShiftReportExportRequest;
  /**
   * Replace this tenant copy's payload from the current master snapshot.
   * Keeps the tenant id, UUID, and questionKey.
   */
  resetOnboardingQuestionFromMaster?: Maybe<OnboardingQuestion>;
  resolveDaySequenceDisputes?: Maybe<Array<Maybe<DaySequence>>>;
  respondToApplication?: Maybe<Scalars['Boolean']['output']>;
  retriggerNotificationsForAction?: Maybe<Scalars['Boolean']['output']>;
  revokeAllMcpApiKeysForTenant: RevokeMcpApiKeysResult;
  revokeAllMcpApiKeysForUser: RevokeMcpApiKeysResult;
  revokeInvite?: Maybe<Scalars['Boolean']['output']>;
  revokeMcpApiKey: Scalars['Boolean']['output'];
  revokeMcpOAuthSession: Scalars['Boolean']['output'];
  sendPushNotification?: Maybe<Scalars['Boolean']['output']>;
  setAccountsForSite?: Maybe<Array<User>>;
  setClassificationLevelClientRate?: Maybe<ClassificationLevelClientRate>;
  setClientRateCard?: Maybe<Client>;
  setClientStatus?: Maybe<Client>;
  setEmailTemplate?: Maybe<EmailTemplate>;
  setSiteStatus: Site;
  setSitesForAccount: Array<Scalars['String']['output']>;
  setTenantDefaultRateCard: CoreLoopConfiguration;
  setupAstuteIntegration?: Maybe<IntegrationConnection>;
  setupBullhornIntegration?: Maybe<IntegrationConnection>;
  setupHubspotIntegration?: Maybe<IntegrationConnection>;
  setupJobAdderIntegration?: Maybe<IntegrationConnection>;
  setupKeypayIntegration?: Maybe<IntegrationConnection>;
  setupVevoIntegration?: Maybe<IntegrationConnection>;
  /**
   * Spawn this tenant's copy of a master question key (no-op if it already exists).
   * Does not create a master row.
   */
  spawnOnboardingQuestionForTenant?: Maybe<OnboardingQuestion>;
  unassignRecruiterFromWorker?: Maybe<Scalars['Boolean']['output']>;
  unassignWorkerFromJob: Job;
  unblockUser?: Maybe<Scalars['Boolean']['output']>;
  unlinkQuestionFromParentQuestion?: Maybe<OnboardingQuestion>;
  updateAllMinimumVersions: AppConfig;
  updateAppConfig: AppConfig;
  updateApprovalStatus?: Maybe<Tenant>;
  updateAssetApprovalStatus?: Maybe<Asset>;
  updateAssetTemplate?: Maybe<AssetTemplate>;
  updateAttributesForIntegrationConnection?: Maybe<IntegrationConnection>;
  updateBankDetailsForCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  updateClassification?: Maybe<Classification>;
  updateClassificationAssetMapping?: Maybe<ClassificationAssetMapping>;
  updateClassificationGroup: ClassificationGroup;
  updateClassificationLevel?: Maybe<ClassificationLevel>;
  updateClient?: Maybe<Client>;
  updateContractTemplate?: Maybe<ContractTemplate>;
  updateCoreLoopConfiguration: CoreLoopConfiguration;
  updateCredentialsForIntegrationConnection?: Maybe<IntegrationConnection>;
  updateCustomAttributeConfiguration: CustomAttributeConfiguration;
  updateExternalAttributeForIntegrationConnection?: Maybe<IntegrationConnection>;
  updateJob: Job;
  updateList: List;
  updateOnboardingTemplate?: Maybe<OnboardingTemplate>;
  updatePolicyTemplate: PolicyTemplate;
  updatePolicyTemplateStatus: PolicyTemplate;
  updateQuestion?: Maybe<OnboardingQuestion>;
  updateSite: Site;
  updateSmartList: SmartList;
  updateTaxDetailsForCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  updateTemplateForTenant: Template;
  updateTenant?: Maybe<Tenant>;
  updateTenantApps?: Maybe<Tenant>;
  /**
   * Update a tenant-owned onboarding question. Refuses master catalogue ids.
   * questionKey cannot be changed.
   */
  updateTenantOnboardingQuestion?: Maybe<OnboardingQuestion>;
  updateTheme: Theme;
  updateUser?: Maybe<User>;
  updateUserAssignedAdmin?: Maybe<User>;
  updateUserFCMToken: Scalars['Boolean']['output'];
  updateUserStatus?: Maybe<User>;
  uploadFile: UploadFileResponse;
  verifyCurrentUserPassword: Scalars['Boolean']['output'];
  withdrawFromJob?: Maybe<Job>;
};


export type MutationAstute_EnsurePayRunPreCheckArgs = {
  runId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationAstute_ForceEnsureClientArgs = {
  clientId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationAstute_ForceEnsureJobArgs = {
  jobId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationAstute_PinOccupationLibraryToClassificationLevelArgs = {
  ASTUTE_OL_OID: Scalars['String']['input'];
  classificationLevelId: Scalars['String']['input'];
  countryHash?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationAstute_RunPayRunPreCheckArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  periodEndISO: Scalars['String']['input'];
  periodStartISO: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationAstute_SetClientBillerArgs = {
  bid: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  wid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAstute_SetIdentifierPolicyArgs = {
  input: Astute_IdentifierPolicyInput;
  tenantId: Scalars['String']['input'];
};


export type MutationAstute_SyncJobAssignmentArgs = {
  jobId: Scalars['String']['input'];
  occupationLibraryOid: Scalars['String']['input'];
  poNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBullhorn_SetPollingConfigArgs = {
  maxConcurrency?: InputMaybe<Scalars['Int']['input']>;
  maxEventsPerPoll?: InputMaybe<Scalars['Int']['input']>;
  pollIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  pollingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationJobadder_ImportPlacementsArgs = {
  placementIds: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationJobadder_SetAuthArgs = {
  accessToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationJobadder_SetInboundImportPolicyArgs = {
  input: Jobadder_InboundImportPolicyInput;
  tenantId: Scalars['String']['input'];
};


export type MutationVevo_ForceCheckUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAbsorbClientArgs = {
  sourceClientId: Scalars['String']['input'];
  targetClientId: Scalars['String']['input'];
};


export type MutationAbsorbSiteArgs = {
  sourceSiteId: Scalars['String']['input'];
  targetSiteId: Scalars['String']['input'];
};


export type MutationAcceptJobArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddClassificationToClientArgs = {
  classificationId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationAddFavouriteUserArgs = {
  clientId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddIntegrationConnectionToTenantArgs = {
  credentials: Array<InputMaybe<CredentialInput>>;
  integrationId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationAddItemsToListArgs = {
  items: Array<ListItemInput>;
  listId: Scalars['String']['input'];
};


export type MutationAddQuestionToMasterListArgs = {
  question: OnboardingQuestionInput;
};


export type MutationAddQuestionToParentQuestionArgs = {
  parentQuestionId: Scalars['String']['input'];
  question: OnboardingQuestionInput;
};


export type MutationAddRequirementToTenantArgs = {
  id: Scalars['String']['input'];
  requirement: Scalars['String']['input'];
};


export type MutationAgreeToContractArgs = {
  contractId: Scalars['String']['input'];
  signature?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAgreeToPolicyArgs = {
  policyId: Scalars['String']['input'];
};


export type MutationApplyForJobArgs = {
  coverLetter?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationApproveDaySequencesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationArchiveChatRoomArgs = {
  chatRoomId: Scalars['String']['input'];
};


export type MutationAssignClassificationLevelToUserArgs = {
  classificationLevelId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAssignRecruiterToWorkerArgs = {
  recruiterId: Scalars['String']['input'];
  workerId: Scalars['String']['input'];
};


export type MutationAssignUserArgs = {
  finalClientPayRateCents?: InputMaybe<Scalars['Int']['input']>;
  finalWorkerPayRateCents?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationBlockUserArgs = {
  ownerId: Scalars['String']['input'];
  ownerType: BlockedUserOwnerType;
  reason?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationBulkClockActionsArgs = {
  entries: Array<ClockEntryInput>;
};


export type MutationBulkSubmitMissingTimesheetsArgs = {
  input: BulkSubmitMissingTimesheetsInput;
};


export type MutationCancelJobArgs = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClearClientRateCardOverrideArgs = {
  clientId: Scalars['String']['input'];
};


export type MutationClockActionArgs = {
  entry: ClockEntryInput;
};


export type MutationClockInArgs = {
  clockTimestamp?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
};


export type MutationClockOutArgs = {
  clockTimestamp?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
};


export type MutationCreateAssetTemplateArgs = {
  input: AssetTemplateInput;
};


export type MutationCreateAuditLogArgs = {
  notes: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type MutationCreateChatRoomArgs = {
  members?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId: Scalars['String']['input'];
};


export type MutationCreateClassificationArgs = {
  classification: ClassificationInput;
};


export type MutationCreateClassificationAssetMappingArgs = {
  classificationId: Scalars['String']['input'];
  entries: Array<ClassificationAssetMappingEntryInput>;
  pageKey: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationCreateClassificationGroupArgs = {
  classificationGroup: ClassificationGroupInput;
};


export type MutationCreateClassificationLevelArgs = {
  classificationLevel: ClassificationLevelInput;
};


export type MutationCreateClientArgs = {
  details: ClientInput;
};


export type MutationCreateContractTemplateArgs = {
  base64PdfContent?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<UserRole>;
  templateHtml?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCustomAttributeConfigurationArgs = {
  input: CustomAttributeConfigurationInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDaySequencesArgs = {
  input: CreateDaySequenceInput;
};


export type MutationCreateJobArgs = {
  input: CreateJobInput;
  questionnaire?: InputMaybe<QuestionnaireInput>;
};


export type MutationCreateListArgs = {
  input: ListInput;
};


export type MutationCreateMcpApiKeyArgs = {
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateOnboardingTemplateVersionArgs = {
  input: OnboardingTemplateInput;
  sourceOnboardingTemplateId: Scalars['String']['input'];
};


export type MutationCreatePaymentIntentArgs = {
  input: CreatePaymentIntentInput;
};


export type MutationCreatePolicyTemplateArgs = {
  input: PolicyTemplateInput;
};


export type MutationCreateReviewArgs = {
  input: ReviewInput;
};


export type MutationCreateSetupIntentArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationCreateSiteArgs = {
  details: SiteInput;
};


export type MutationCreateSmartListArgs = {
  input: SmartListInput;
};


export type MutationCreateTenantArgs = {
  details: TenantInput;
};


export type MutationCreateTenantOnboardingQuestionArgs = {
  question: OnboardingQuestionInput;
  tenantId: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  details: UserInput;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteAllInboxItemsArgs = {
  onlyDeleteReadItems?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['String']['input'];
};


export type MutationDeleteAssetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAssetTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteClassificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteClassificationAssetMappingArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteClassificationGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteClassificationLevelArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCustomAttributeConfigurationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDaySequencesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteInboxItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteIntegrationConnectionArgs = {
  integrationConnectionId: Scalars['String']['input'];
};


export type MutationDeleteJobArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteListArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationDeletePolicyTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteReviewArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSiteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSmartListArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTenantArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDismissJobRatingArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationDisputeDaySequencesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationEditNoteArgs = {
  id: Scalars['String']['input'];
  input: EditNoteInput;
};


export type MutationEditReviewArgs = {
  id: Scalars['String']['input'];
  input?: InputMaybe<ReviewInput>;
};


export type MutationEnableIntegrationConnectionArgs = {
  integrationConnectionId: Scalars['String']['input'];
  shouldEnable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEnableMaintenanceArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};


export type MutationEscalateChatRoomArgs = {
  chatRoomId: Scalars['String']['input'];
};


export type MutationExcludeJobFromReliabilityScoreArgs = {
  jobId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationForceSyncPartialPayRunCycleLogArgs = {
  jobIds: Array<Scalars['String']['input']>;
  payRunCycleLogId: Scalars['String']['input'];
};


export type MutationForceSyncPayRunCycleLogArgs = {
  id: Scalars['String']['input'];
};


export type MutationGenerateInvoicesArgs = {
  commitChanges?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationImportClassificationMappingArgs = {
  csv: Scalars['String']['input'];
  platform: SupportedIntegrationPlatform;
  tenantId: Scalars['String']['input'];
};


export type MutationImportDataArgs = {
  input: ImporterInput;
};


export type MutationImportStatusMappingArgs = {
  csv: Scalars['String']['input'];
  platform: SupportedIntegrationPlatform;
  tenantId: Scalars['String']['input'];
};


export type MutationInitiatePayRunForTenantArgs = {
  allOrNothingMode?: InputMaybe<Scalars['Boolean']['input']>;
  attemptToFixErrors?: InputMaybe<Scalars['Boolean']['input']>;
  periodEndISO?: InputMaybe<Scalars['String']['input']>;
  periodStartISO?: InputMaybe<Scalars['String']['input']>;
  shouldSave?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationInitiateUserSelfDeletionArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteUserArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  role: UserRole;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationJobAdderConsumeAuthCodeArgs = {
  code: Scalars['String']['input'];
  environment: IntegrationEnvironment;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationJobAdderRefreshAccessTokenArgs = {
  environment: IntegrationEnvironment;
  tenantId: Scalars['String']['input'];
};


export type MutationJoinChatRoomArgs = {
  chatRoomId: Scalars['String']['input'];
};


export type MutationLinkQuestionToParentQuestionArgs = {
  childQuestionKey: Scalars['String']['input'];
  parentQuestionId: Scalars['String']['input'];
  visibility?: InputMaybe<QuestionVisibilityInput>;
};


export type MutationMarkAllInboxItemsAsReadArgs = {
  ownerId: Scalars['String']['input'];
};


export type MutationMarkDaySequenceNotWorkedArgs = {
  dateISO: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};


export type MutationMarkInboxItemAsReadArgs = {
  id: Scalars['String']['input'];
};


export type MutationMergeClientsArgs = {
  clientIds: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceClientId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationNormaliseClientAndSiteAddressesArgs = {
  tenantId: Scalars['String']['input'];
};


export type MutationProcessPartialUpdatesArgs = {
  allOrNothingUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  updates: Array<PartialUpdateInput>;
};


export type MutationProposeDaySequenceChangesArgs = {
  daySequenceChanges: Array<DaySequenceChangeInput>;
};


export type MutationRemoveClassificationFromClientArgs = {
  classificationId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationRemoveClassificationLevelFromUserArgs = {
  classificationLevelId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveFavouriteUserArgs = {
  clientId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveItemsFromListArgs = {
  items: Array<Scalars['String']['input']>;
  listId: Scalars['String']['input'];
};


export type MutationRemoveRequirementFromTenantArgs = {
  id: Scalars['String']['input'];
  requirement: Scalars['String']['input'];
};


export type MutationReorderChildQuestionsForParentQuestionArgs = {
  childQuestionOrder: Array<Scalars['String']['input']>;
  parentQuestionId: Scalars['String']['input'];
};


export type MutationRequestPredictiveShiftReportExportArgs = {
  endDate: Scalars['String']['input'];
  includeUnfilledShifts?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetOnboardingQuestionFromMasterArgs = {
  questionKey: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationResolveDaySequenceDisputesArgs = {
  daySequenceChanges: Array<DaySequenceChangeInput>;
};


export type MutationRespondToApplicationArgs = {
  finalClientPayRateCents?: InputMaybe<Scalars['Int']['input']>;
  finalWorkerPayRateCents?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  status: JobApplicationStatus;
};


export type MutationRetriggerNotificationsForActionArgs = {
  action: NotificationAction;
  objectId: Scalars['String']['input'];
};


export type MutationRevokeAllMcpApiKeysForTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type MutationRevokeAllMcpApiKeysForUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRevokeInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationRevokeMcpApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type MutationRevokeMcpOAuthSessionArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendPushNotificationArgs = {
  notificationBody?: InputMaybe<Scalars['String']['input']>;
  notificationTitle?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};


export type MutationSetAccountsForSiteArgs = {
  clientUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  inviteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  siteId: Scalars['String']['input'];
};


export type MutationSetClassificationLevelClientRateArgs = {
  classificationLevelId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  minimums: Array<MinimumInput>;
};


export type MutationSetClientRateCardArgs = {
  clientId: Scalars['String']['input'];
  rateCard: ClientRateCardInput;
};


export type MutationSetClientStatusArgs = {
  id: Scalars['String']['input'];
  status: ClientStatus;
};


export type MutationSetEmailTemplateArgs = {
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  type?: InputMaybe<EmailTemplateType>;
};


export type MutationSetSiteStatusArgs = {
  id: Scalars['String']['input'];
  status: SiteStatus;
};


export type MutationSetSitesForAccountArgs = {
  clientUserId?: InputMaybe<Scalars['String']['input']>;
  inviteId?: InputMaybe<Scalars['String']['input']>;
  siteIds: Array<Scalars['String']['input']>;
};


export type MutationSetTenantDefaultRateCardArgs = {
  rateCard?: InputMaybe<ClientRateCardInput>;
  tenantId: Scalars['String']['input'];
};


export type MutationSetupAstuteIntegrationArgs = {
  credentials: AstuteIntegrationCredentialsInput;
  enableIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  environment: IntegrationEnvironment;
  tenantId: Scalars['String']['input'];
  timesheetMode?: InputMaybe<AstuteTimesheetMode>;
};


export type MutationSetupBullhornIntegrationArgs = {
  credentials: BullhornIntegrationCredentialsInput;
  enableIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationSetupHubspotIntegrationArgs = {
  credentials: HubspotIntegrationCredentialsInput;
  enableIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationSetupJobAdderIntegrationArgs = {
  credentials: JobAdderIntegrationCredentialsInput;
  enableIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  environment: IntegrationEnvironment;
  tenantId: Scalars['String']['input'];
};


export type MutationSetupKeypayIntegrationArgs = {
  credentials: KeypayIntegrationCredentialsInput;
  enableIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationSetupVevoIntegrationArgs = {
  enableIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationSpawnOnboardingQuestionForTenantArgs = {
  questionKey: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationUnassignRecruiterFromWorkerArgs = {
  recruiterId: Scalars['String']['input'];
  workerId: Scalars['String']['input'];
};


export type MutationUnassignWorkerFromJobArgs = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnblockUserArgs = {
  ownerId: Scalars['String']['input'];
  ownerType: BlockedUserOwnerType;
  userId: Scalars['String']['input'];
};


export type MutationUnlinkQuestionFromParentQuestionArgs = {
  childQuestionKey: Scalars['String']['input'];
  parentQuestionId: Scalars['String']['input'];
};


export type MutationUpdateAllMinimumVersionsArgs = {
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  minimumVersion: Scalars['String']['input'];
  recommendedVersion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAppConfigArgs = {
  input: AppConfigInput;
};


export type MutationUpdateApprovalStatusArgs = {
  status: TenantApprovalStatus;
  tenantId: Scalars['String']['input'];
};


export type MutationUpdateAssetApprovalStatusArgs = {
  assetId: Scalars['String']['input'];
  status: AssetStatus;
};


export type MutationUpdateAssetTemplateArgs = {
  id: Scalars['String']['input'];
  input: AssetTemplateUpdateInput;
};


export type MutationUpdateAttributesForIntegrationConnectionArgs = {
  attributes: Array<IntegrationConnectionAttributeInput>;
  integrationConnectionId: Scalars['String']['input'];
};


export type MutationUpdateBankDetailsForCurrentUserArgs = {
  bankDetails: BankDetailsInput;
};


export type MutationUpdateClassificationArgs = {
  classification: ClassificationInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateClassificationAssetMappingArgs = {
  entries: Array<ClassificationAssetMappingEntryInput>;
  id: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationUpdateClassificationGroupArgs = {
  classificationGroup: ClassificationGroupInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateClassificationLevelArgs = {
  classificationLevel: ClassificationLevelInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateClientArgs = {
  details: ClientInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateContractTemplateArgs = {
  base64PdfContent?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<UserRole>;
  templateHtml?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCoreLoopConfigurationArgs = {
  input: CoreLoopConfigurationInput;
};


export type MutationUpdateCredentialsForIntegrationConnectionArgs = {
  credentials: Array<InputMaybe<CredentialInput>>;
  integrationConnectionId: Scalars['String']['input'];
};


export type MutationUpdateCustomAttributeConfigurationArgs = {
  id: Scalars['String']['input'];
  input: CustomAttributeConfigurationInput;
};


export type MutationUpdateExternalAttributeForIntegrationConnectionArgs = {
  externalAttributeName: Scalars['String']['input'];
  integrationConnectionId: Scalars['String']['input'];
  localAttributeName: Scalars['String']['input'];
};


export type MutationUpdateJobArgs = {
  id: Scalars['String']['input'];
  input: UpdateJobInput;
};


export type MutationUpdateListArgs = {
  id: Scalars['String']['input'];
  input: ListInput;
};


export type MutationUpdateOnboardingTemplateArgs = {
  input: OnboardingTemplateInput;
  onboardingTemplateId: Scalars['String']['input'];
};


export type MutationUpdatePolicyTemplateArgs = {
  id: Scalars['String']['input'];
  input: PolicyTemplateInput;
};


export type MutationUpdatePolicyTemplateStatusArgs = {
  id: Scalars['String']['input'];
  status: PolicyStatus;
};


export type MutationUpdateQuestionArgs = {
  input: OnboardingQuestionInput;
  questionId: Scalars['String']['input'];
};


export type MutationUpdateSiteArgs = {
  details: SiteInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateSmartListArgs = {
  id: Scalars['String']['input'];
  input: SmartListInput;
};


export type MutationUpdateTaxDetailsForCurrentUserArgs = {
  taxDetails: TaxDetailsInput;
};


export type MutationUpdateTemplateForTenantArgs = {
  _ASSET_LIST_?: InputMaybe<Array<InputMaybe<AssetTemplateInput>>>;
  _CANCEL_TERM_?: InputMaybe<Scalars['String']['input']>;
  _CLIENT_TERM_?: InputMaybe<Scalars['String']['input']>;
  _INVOICE_NUMBER_PREFIX_?: InputMaybe<Scalars['String']['input']>;
  _INVOICE_TERMS_?: InputMaybe<Scalars['String']['input']>;
  _JOB_TABLE_FRONT_COLUMNS_?: InputMaybe<Array<Scalars['String']['input']>>;
  _JOB_TERM_?: InputMaybe<Scalars['String']['input']>;
  _PAY_RATE_LEVEL_TERM_?: InputMaybe<Scalars['String']['input']>;
  _TENANT_TERM_?: InputMaybe<Scalars['String']['input']>;
  _WORKER_TERM_?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationUpdateTenantArgs = {
  details: TenantInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateTenantAppsArgs = {
  apps: Array<TenantAppInput>;
  tenantId: Scalars['String']['input'];
};


export type MutationUpdateTenantOnboardingQuestionArgs = {
  input: OnboardingQuestionInput;
  questionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationUpdateThemeArgs = {
  theme: ThemeInput;
  themeId: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  details: UserInput;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserAssignedAdminArgs = {
  assignedAdminId: Scalars['String']['input'];
  changeReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationUpdateUserFcmTokenArgs = {
  fcmToken: Scalars['String']['input'];
  metadata?: InputMaybe<FcmTokenMetadataInput>;
};


export type MutationUpdateUserStatusArgs = {
  id: Scalars['String']['input'];
  status: UserStatus;
};


export type MutationUploadFileArgs = {
  input: UploadFileInput;
};


export type MutationVerifyCurrentUserPasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationWithdrawFromJobArgs = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Internal agency note attached to a domain object. Currently supported for users
 * (candidate profile). Never exposed to candidates or clients.
 */
export type Note = {
  __typename?: 'Note';
  /** Free-text note body. Max 500 characters. */
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  objectType: ObjectType;
  /**
   * Email of the agency user who created the note, resolved at query time.
   * Agency users may not have first/last names, so email is the display identity.
   */
  ownerEmail?: Maybe<Scalars['String']['output']>;
  /** Agency user who owns and may edit the note. */
  ownerId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum NotificationAction {
  JobPosted = 'JOB_POSTED'
}

export enum ObjectType {
  Asset = 'ASSET',
  AssetTemplate = 'ASSET_TEMPLATE',
  AuditLog = 'AUDIT_LOG',
  BankDetails = 'BANK_DETAILS',
  BlockedUser = 'BLOCKED_USER',
  BudgetRecord = 'BUDGET_RECORD',
  ChatMessage = 'CHAT_MESSAGE',
  ChatRoom = 'CHAT_ROOM',
  Classification = 'CLASSIFICATION',
  ClassificationAssetMapping = 'CLASSIFICATION_ASSET_MAPPING',
  ClassificationGroup = 'CLASSIFICATION_GROUP',
  ClassificationLevel = 'CLASSIFICATION_LEVEL',
  ClassificationLevelClientRate = 'CLASSIFICATION_LEVEL_CLIENT_RATE',
  Client = 'CLIENT',
  ClientPeriodBill = 'CLIENT_PERIOD_BILL',
  Contract = 'CONTRACT',
  ContractTemplate = 'CONTRACT_TEMPLATE',
  CoreLoopConfiguration = 'CORE_LOOP_CONFIGURATION',
  Credential = 'CREDENTIAL',
  CustomAttribute = 'CUSTOM_ATTRIBUTE',
  CustomAttributeConfiguration = 'CUSTOM_ATTRIBUTE_CONFIGURATION',
  DaySequence = 'DAY_SEQUENCE',
  DeferredAction = 'DEFERRED_ACTION',
  Delegate = 'DELEGATE',
  Device = 'DEVICE',
  EmailTemplate = 'EMAIL_TEMPLATE',
  EncryptedCredentialItem = 'ENCRYPTED_CREDENTIAL_ITEM',
  EphemeralDelegate = 'EPHEMERAL_DELEGATE',
  FavouriteUser = 'FAVOURITE_USER',
  FcmToken = 'FCM_TOKEN',
  Feature = 'FEATURE',
  InboxItem = 'INBOX_ITEM',
  Initializer = 'INITIALIZER',
  Integration = 'INTEGRATION',
  IntegrationConnection = 'INTEGRATION_CONNECTION',
  Invite = 'INVITE',
  Invoice = 'INVOICE',
  InvoicesExport = 'INVOICES_EXPORT',
  InvoiceItem = 'INVOICE_ITEM',
  Job = 'JOB',
  JobApplication = 'JOB_APPLICATION',
  List = 'LIST',
  ListItem = 'LIST_ITEM',
  MasterOnboardingQuestion = 'MASTER_ONBOARDING_QUESTION',
  McpApiKey = 'MCP_API_KEY',
  McpOauthAuthCode = 'MCP_OAUTH_AUTH_CODE',
  McpOauthSession = 'MCP_OAUTH_SESSION',
  McpQueryLog = 'MCP_QUERY_LOG',
  Note = 'NOTE',
  Onboarding = 'ONBOARDING',
  OnboardingQuestion = 'ONBOARDING_QUESTION',
  OnboardingTemplate = 'ONBOARDING_TEMPLATE',
  PayRun = 'PAY_RUN',
  PayRunCycleLog = 'PAY_RUN_CYCLE_LOG',
  PayRunExport = 'PAY_RUN_EXPORT',
  Policy = 'POLICY',
  PolicyTemplate = 'POLICY_TEMPLATE',
  PushNotificationTemplate = 'PUSH_NOTIFICATION_TEMPLATE',
  Questionnaire = 'QUESTIONNAIRE',
  QuestionnaireQuestion = 'QUESTIONNAIRE_QUESTION',
  Review = 'REVIEW',
  Site = 'SITE',
  SmartList = 'SMART_LIST',
  SocketConnection = 'SOCKET_CONNECTION',
  StatusMapping = 'STATUS_MAPPING',
  StoredCredential = 'STORED_CREDENTIAL',
  TaxDetails = 'TAX_DETAILS',
  Template = 'TEMPLATE',
  Tenant = 'TENANT',
  TenantApp = 'TENANT_APP',
  TenantMobileAppHelper = 'TENANT_MOBILE_APP_HELPER',
  TenantPayConfiguration = 'TENANT_PAY_CONFIGURATION',
  Theme = 'THEME',
  UsagePlan = 'USAGE_PLAN',
  User = 'USER',
  VevoCheck = 'VEVO_CHECK',
  Worker = 'WORKER'
}

export type Onboarding = {
  __typename?: 'Onboarding';
  currentPageId: Scalars['String']['output'];
  onboardingJSON: Scalars['JSON']['output'];
  status: OnboardingStatus;
  userId: Scalars['String']['output'];
};

export type OnboardingPage = {
  __typename?: 'OnboardingPage';
  canSkip: Scalars['Boolean']['output'];
  /** When omitted, hire contract pages use PRIMARY (legacy single-contract behaviour). */
  contractType?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  fontAwesomeIcon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  questionKeys?: Maybe<Array<Scalars['String']['output']>>;
  questions?: Maybe<Array<OnboardingQuestion>>;
  title: Scalars['String']['output'];
  type: OnboardingPageType;
};

export type OnboardingPageInput = {
  canSkip: Scalars['Boolean']['input'];
  contractType?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  fontAwesomeIcon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  key: Scalars['String']['input'];
  questionKeys: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: OnboardingPageType;
};

export enum OnboardingPageType {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC'
}

export type OnboardingQuestion = {
  __typename?: 'OnboardingQuestion';
  childQuestions?: Maybe<Array<OnboardingQuestion>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  infoPanel?: Maybe<Array<InfoPanel>>;
  key: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  objectAttributeToManipulate?: Maybe<Scalars['String']['output']>;
  objectIdToManipulate?: Maybe<Scalars['String']['output']>;
  objectToManipulate?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<QuestionOption>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  requiresValidationOnDevice?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  type: OnboardingQuestionType;
  validations?: Maybe<Array<QuestionValidation>>;
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<ValueType>;
  visibility?: Maybe<QuestionVisibility>;
};

export type OnboardingQuestionInput = {
  description: Scalars['String']['input'];
  infoPanel?: InputMaybe<Array<InfoPanelInput>>;
  /**
   * Stable question identifier (camelCase, e.g. firstName).
   * When omitted on create, derived from title. Cannot be changed after create.
   */
  key?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  objectAttributeToManipulate?: InputMaybe<Scalars['String']['input']>;
  objectIdToManipulate?: InputMaybe<Scalars['String']['input']>;
  objectToManipulate?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<QuestionOptionInput>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
  requiresValidationOnDevice?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: OnboardingQuestionType;
  validations?: InputMaybe<Array<QuestionValidationInput>>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueType?: InputMaybe<ValueType>;
  visibility?: InputMaybe<QuestionVisibilityInput>;
};

export enum OnboardingQuestionType {
  Address = 'ADDRESS',
  AgreeToPolicy = 'AGREE_TO_POLICY',
  BankAccount = 'BANK_ACCOUNT',
  Boolean = 'BOOLEAN',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  DisplayOnly = 'DISPLAY_ONLY',
  Dropdown = 'DROPDOWN',
  Email = 'EMAIL',
  EnableLocation = 'ENABLE_LOCATION',
  EnableNotification = 'ENABLE_NOTIFICATION',
  FileUpload = 'FILE_UPLOAD',
  Multiple = 'MULTIPLE',
  MultiLineTextInput = 'MULTI_LINE_TEXT_INPUT',
  MultiSelect = 'MULTI_SELECT',
  NoDisplay = 'NO_DISPLAY',
  Phone = 'PHONE',
  PhotoUpload = 'PHOTO_UPLOAD',
  Policy = 'POLICY',
  Radio = 'RADIO',
  Signature = 'SIGNATURE',
  SingleSelect = 'SINGLE_SELECT',
  TextInput = 'TEXT_INPUT',
  Time = 'TIME',
  ValueSlider = 'VALUE_SLIDER'
}

export enum OnboardingRole {
  Client = 'CLIENT',
  ClientAdmin = 'CLIENT_ADMIN',
  ClientUser = 'CLIENT_USER',
  ClientViewer = 'CLIENT_VIEWER',
  Worker = 'WORKER'
}

export enum OnboardingStatus {
  Abandoned = 'ABANDONED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type OnboardingTemplate = {
  __typename?: 'OnboardingTemplate';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  pages: Array<OnboardingPage>;
  role: OnboardingRole;
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type OnboardingTemplateInput = {
  isActive: Scalars['Boolean']['input'];
  pages: Array<OnboardingPageInput>;
  version: Scalars['String']['input'];
};

export type PaginatedChatRoomResponse = {
  __typename?: 'PaginatedChatRoomResponse';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items: Array<Maybe<ChatRoom>>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
};

export type PaginatedClientResponse = {
  __typename?: 'PaginatedClientResponse';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items: Array<Client>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
};

export type PaginatedDaySequenceResponse = {
  __typename?: 'PaginatedDaySequenceResponse';
  daySequences: Array<DaySequence>;
  hasMore: Scalars['Boolean']['output'];
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
};

export type PaginatedJobResponse = {
  __typename?: 'PaginatedJobResponse';
  hasMore: Scalars['Boolean']['output'];
  jobs: Array<Maybe<Job>>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
};

export type PaginatedTimesheetApprovalResponse = {
  __typename?: 'PaginatedTimesheetApprovalResponse';
  hasMore: Scalars['Boolean']['output'];
  items: Array<TimesheetApprovalItem>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
};

export type PaginatedUserResponse = {
  __typename?: 'PaginatedUserResponse';
  hasMore: Scalars['Boolean']['output'];
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
};

export type PartialUpdateError = {
  __typename?: 'PartialUpdateError';
  errorType: PartialUpdateErrorType;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PartialUpdateErrorType {
  AllOrNothingFailed = 'ALL_OR_NOTHING_FAILED',
  InvalidAttributeName = 'INVALID_ATTRIBUTE_NAME',
  InvalidObject = 'INVALID_OBJECT',
  InvalidObjectId = 'INVALID_OBJECT_ID',
  InvalidObjectType = 'INVALID_OBJECT_TYPE',
  InvalidValue = 'INVALID_VALUE',
  InvalidValueType = 'INVALID_VALUE_TYPE',
  PermissionDenied = 'PERMISSION_DENIED',
  UnknownError = 'UNKNOWN_ERROR'
}

export type PartialUpdateInput = {
  attributeName: Scalars['String']['input'];
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  objectId: Scalars['String']['input'];
  objectType: ObjectType;
  value: Scalars['String']['input'];
  valueType?: InputMaybe<ValueType>;
};

export type PartialUpdateResult = {
  __typename?: 'PartialUpdateResult';
  failedUpdates: Array<Update>;
  successfulUpdates: Array<Update>;
};

export type PayRun = {
  __typename?: 'PayRun';
  client: Client;
  id: Scalars['String']['output'];
  payRunDateFromISO: Scalars['String']['output'];
  payRunDateToISO: Scalars['String']['output'];
  payRunDurationInDays: Scalars['Int']['output'];
  payRunItems: Array<Maybe<PayRunItem>>;
  payRunNotes: Array<Maybe<PayRunNote>>;
  payRunPerformedAt: Scalars['String']['output'];
  payRunStatus: PayRunStatus;
  payableAmountCents: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  totalBreakHours: Scalars['Float']['output'];
  totalHours: Scalars['Float']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type PayRunCycleLog = {
  __typename?: 'PayRunCycleLog';
  autoFixedItemsSummary: Array<Scalars['String']['output']>;
  clientBillIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  errorSummary: Array<Scalars['String']['output']>;
  externalReferences: Scalars['JSON']['output'];
  fileKey: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  payRunCount: Scalars['Int']['output'];
  payRunDateFromISO: Scalars['String']['output'];
  payRunDateToISO: Scalars['String']['output'];
  payRunIds: Array<Scalars['String']['output']>;
  payRuns: Array<PayRun>;
  payrollSyncReportKey?: Maybe<Scalars['String']['output']>;
  payrollSyncReportUrl?: Maybe<Scalars['String']['output']>;
  periodEndISO: Scalars['String']['output'];
  periodLengthInDays: Scalars['Int']['output'];
  periodStartISO: Scalars['String']['output'];
  status: PayRunCycleLogStatus;
  tenant: Tenant;
  totalClientBillableAmountCents: Scalars['Int']['output'];
  totalPayableAmountCents: Scalars['Int']['output'];
};

export enum PayRunCycleLogStatus {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export type PayRunItem = {
  __typename?: 'PayRunItem';
  breakHours: Scalars['Float']['output'];
  checkInTime: Scalars['String']['output'];
  checkOutTime: Scalars['String']['output'];
  classificationId: Scalars['String']['output'];
  classificationLevelId: Scalars['String']['output'];
  client: Client;
  clientBillable: Scalars['Float']['output'];
  clientBillableAmountInCents: Scalars['Int']['output'];
  clientId: Scalars['String']['output'];
  dateISO: Scalars['String']['output'];
  daySequence: DaySequence;
  daySequenceId: Scalars['String']['output'];
  hoursWorked: Scalars['Float']['output'];
  job: Job;
  jobId: Scalars['String']['output'];
  paidBreakInMs: Scalars['Int']['output'];
  payRatePerHour: Scalars['Float']['output'];
  payRatePerHourInCents: Scalars['Int']['output'];
  timeWorkedInMs: Scalars['Int']['output'];
  totalPay: Scalars['Float']['output'];
  totalPayableAmountInCents: Scalars['Int']['output'];
  unpaidBreakInMs: Scalars['Int']['output'];
};

export type PayRunNote = {
  __typename?: 'PayRunNote';
  createdAt: Scalars['String']['output'];
  notes: Scalars['String']['output'];
};

export enum PayRunStatus {
  Complete = 'COMPLETE',
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  amount: Scalars['Int']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card?: Maybe<Card>;
  customer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type PendingWorkerRating = {
  __typename?: 'PendingWorkerRating';
  classificationName: Scalars['String']['output'];
  existingRating?: Maybe<Scalars['Float']['output']>;
  isFavourite: Scalars['Boolean']['output'];
  jobId: Scalars['String']['output'];
  timesheetCount: Scalars['Int']['output'];
  workerFirstName: Scalars['String']['output'];
  workerLastName: Scalars['String']['output'];
  workerProfilePictureUrl?: Maybe<Scalars['String']['output']>;
};

export type Policy = {
  __typename?: 'Policy';
  agreedAt: Scalars['String']['output'];
  agreedBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isAgreedTo: Scalars['Boolean']['output'];
  ownerId: Scalars['String']['output'];
  pdfUrl: Scalars['String']['output'];
  policyHtmlContent: Scalars['String']['output'];
  policyType: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export enum PolicyStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Superseded = 'SUPERSEDED'
}

export type PolicyTemplate = {
  __typename?: 'PolicyTemplate';
  id: Scalars['String']['output'];
  policyHtmlContent: Scalars['String']['output'];
  policyType: Scalars['String']['output'];
  policyVersion: Scalars['String']['output'];
  status: PolicyStatus;
  tenantId: Scalars['String']['output'];
};

export type PolicyTemplateInput = {
  base64PdfContent?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  policyHtmlContent?: InputMaybe<Scalars['String']['input']>;
  policyType?: InputMaybe<Scalars['String']['input']>;
  policyVersion?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PolicyStatus>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type PotentialPayRates = {
  __typename?: 'PotentialPayRates';
  potentialClientPayRateAverageInCents?: Maybe<Scalars['Int']['output']>;
  potentialClientPayRateCeilingInCents?: Maybe<Scalars['Int']['output']>;
  potentialClientPayRateFloorInCents?: Maybe<Scalars['Int']['output']>;
  potentialClientPayRateMedianInCents?: Maybe<Scalars['Int']['output']>;
  potentialWorkerPayRateAverageInCents?: Maybe<Scalars['Int']['output']>;
  potentialWorkerPayRateCeilingInCents?: Maybe<Scalars['Int']['output']>;
  potentialWorkerPayRateFloorInCents?: Maybe<Scalars['Int']['output']>;
  potentialWorkerPayRateForUserIdInCents?: Maybe<Scalars['Int']['output']>;
  potentialWorkerPayRateMedianInCents?: Maybe<Scalars['Int']['output']>;
};

export type PredictiveShiftReportExportRequest = {
  __typename?: 'PredictiveShiftReportExportRequest';
  id: Scalars['String']['output'];
  status: PredictiveShiftReportExportStatus;
};

export enum PredictiveShiftReportExportStatus {
  Queued = 'QUEUED'
}

export type Query = {
  __typename?: 'Query';
  ASTUTE_getIdentifierPolicy: Astute_IdentifierPolicy;
  ASTUTE_getOccupationLibraries: Array<Astute_OccupationLibrary>;
  ASTUTE_preCheckPayRun: Astute_PayRunPreCheck;
  ATS_explore?: Maybe<Scalars['JSON']['output']>;
  ATS_getExplorerSchema?: Maybe<Scalars['JSON']['output']>;
  BULLHORN_getConfiguration: Bullhorn_Configuration;
  EXTERNAL_findRecords?: Maybe<Scalars['JSON']['output']>;
  JOBADDER_getInboundImportPolicy: Jobadder_InboundImportPolicy;
  chatRoomForJob: ChatRoom;
  chatRoomsForClient: PaginatedChatRoomResponse;
  chatRoomsForTenant: PaginatedChatRoomResponse;
  chatRoomsForUser: Array<ChatRoom>;
  credentialsForIntegrationConnection?: Maybe<Array<Scalars['JSON']['output']>>;
  fetchCustomAttributesForObjectId: Array<CustomAttribute>;
  fetchExternalReferencesForObjectId: Array<ExternalReference>;
  getAiResponse: Scalars['String']['output'];
  getAllClients?: Maybe<PaginatedClientResponse>;
  getAllClientsForTenant?: Maybe<PaginatedClientResponse>;
  getAllIntegrations?: Maybe<Array<Integration>>;
  getAllJobsByStatusForUserId: PaginatedJobResponse;
  getAllJobsForClient: PaginatedJobResponse;
  getAllJobsForClientBetweenDates: PaginatedJobResponse;
  getAllJobsForSite: PaginatedJobResponse;
  getAllJobsForTenant: PaginatedJobResponse;
  getAllJobsForTenantBetweenDates: PaginatedJobResponse;
  getAllPotentialJobsForUserId: Array<Job>;
  getAllSmartListsForUser: Array<SmartList>;
  getAllTenants?: Maybe<Array<Tenant>>;
  getAllThemes: Array<Theme>;
  getAppConfig: AppConfig;
  getAsset?: Maybe<Asset>;
  getAssetTemplatesForTenant?: Maybe<Array<AssetTemplate>>;
  getAssetsForUser?: Maybe<Array<Asset>>;
  getAuditLogForObject: Array<Maybe<AuditLog>>;
  getBankAndTaxDetailsForCurrentUser: Array<CustomAttribute>;
  getBankDetailsForCurrentUser?: Maybe<BankDetails>;
  getBlockedUsersForOwner?: Maybe<Array<BlockedUser>>;
  getBlocksForUser?: Maybe<Array<BlockedUser>>;
  getBudgetLimits: Array<BudgetLimits>;
  getClassification: Classification;
  getClassificationAssetMappingForTenant: Array<ClassificationAssetMapping>;
  getClassificationGroup: ClassificationGroup;
  getClassificationGroups?: Maybe<Array<ClassificationGroup>>;
  getClassificationLevelClientRates: Array<ClassificationLevelClientRate>;
  getClient?: Maybe<Client>;
  getClientPeriodBill: ClientPeriodBill;
  getClientRateCard?: Maybe<ClientRateCard>;
  getContract?: Maybe<Contract>;
  getContractTemplate?: Maybe<ContractTemplate>;
  getContractsByOwnerId?: Maybe<Array<Contract>>;
  getCoreLoopConfiguration: CoreLoopConfiguration;
  getCurrentRatingForUser?: Maybe<Scalars['Float']['output']>;
  getCurrentUser: User;
  getCustomAttributeConfigurations: Array<CustomAttributeConfiguration>;
  getCustomerByTenantId?: Maybe<Customer>;
  getDaySequenceById: DaySequence;
  getDaySequenceForJobForDate?: Maybe<DaySequence>;
  getDaySequencesByJobIds: Array<DaySequence>;
  getDaySequencesForClient: Array<DaySequence>;
  getDaySequencesForJob: PaginatedDaySequenceResponse;
  getDaySequencesForUser: Array<DaySequence>;
  getDaySequencesRequiringAction: Array<DaySequence>;
  getEmailTemplate?: Maybe<EmailTemplate>;
  getEmailTemplates: Array<Maybe<EmailTemplate>>;
  getFavouriteUsers?: Maybe<Array<FavouriteUser>>;
  getInboxForOwner: Array<InboxItem>;
  getInboxItem: InboxItem;
  getIntegration?: Maybe<Integration>;
  getIntegrationConnection?: Maybe<IntegrationConnection>;
  getIntegrationConnectionsForTenant?: Maybe<Array<IntegrationConnection>>;
  getIntegrationInitializationSchema?: Maybe<Array<IntegrationInitializationSchema>>;
  getInviteByCode?: Maybe<Invite>;
  getInvitesSentByUser?: Maybe<Array<Invite>>;
  getInvoice: Invoice;
  getInvoicesForClient: Array<Invoice>;
  getInvoicesForClientWithStatus: Array<Invoice>;
  getInvoicesForTenant: Array<Invoice>;
  getInvoicesForTenantWithStatus: Array<Invoice>;
  getJob?: Maybe<Job>;
  getJobApplication: JobApplication;
  getJobApplicationsForClient: Array<JobApplication>;
  getJobApplicationsForJob: Array<JobApplication>;
  getJobApplicationsForTenant: Array<JobApplication>;
  getJobApplicationsForUser: Array<JobApplication>;
  getJobPostingQuestionnaire: Questionnaire;
  getList: List;
  getListsForOwner?: Maybe<Array<List>>;
  getMcpLogsForUser: McpQueryLogPaginatedResult;
  getMcpOAuthConnectionInfo: McpOAuthConnectionInfo;
  getMissingTimesheets: MissingTimesheetsResult;
  /** Returns a note by its ID. */
  getNoteById?: Maybe<Note>;
  /** Returns all notes attached to object, newest first. */
  getNotesForObject: Array<Note>;
  getOnboarding?: Maybe<Onboarding>;
  getOnboardingForUser?: Maybe<Onboarding>;
  /**
   * Fetch-or-spawn onboarding questions this tenant uses (template keys,
   * classification mapping keys, and children). Returns tenant copies only.
   */
  getOnboardingQuestionsForTenant: Array<OnboardingQuestion>;
  getOnboardingTemplate?: Maybe<OnboardingTemplate>;
  getOutstandingInvitesForClient?: Maybe<Array<Invite>>;
  getOutstandingInvitesForTenant?: Maybe<Array<Invite>>;
  getPayRun: PayRun;
  getPayRunCycleLog: PayRunCycleLog;
  getPayRunCycleLogs: Array<PayRunCycleLog>;
  getPayRunReadyness: Scalars['String']['output'];
  getPaymentMethodByCustomerId: Array<PaymentMethod>;
  /**
   * Completed jobs needing a rating prompt. Returns [] when the tenant's
   * CoreLoopConfiguration.enableClientWorkerRatingPrompt is false. At most one
   * row per worker — always the latest completed job (by end/start date).
   * existingRating is set when the client should see "Update your rating of [name]".
   */
  getPendingWorkerRatingsForClient: Array<PendingWorkerRating>;
  getPermissionsForCurrentUser: Array<Maybe<Scalars['String']['output']>>;
  getPoliciesByOwnerId?: Maybe<Array<Policy>>;
  getPolicy?: Maybe<Policy>;
  getPolicyTemplate?: Maybe<PolicyTemplate>;
  getPolicyTemplatesByTenantId?: Maybe<Array<PolicyTemplate>>;
  getQuestionMasterList: Array<OnboardingQuestion>;
  getReview?: Maybe<Review>;
  getReviewsForObject: Array<Maybe<Review>>;
  getSite?: Maybe<Site>;
  getSitesForClient: Array<Site>;
  getSmartList: SmartList;
  getStatsForCurrentUser: WorkerStats;
  getSuperDetailsForCurrentUser: Array<CustomAttribute>;
  getSupportedImporters?: Maybe<Array<Importer>>;
  getTaxDetailsForCurrentUser?: Maybe<TaxDetails>;
  getTemplatesByTenantId?: Maybe<Array<ContractTemplate>>;
  getTenant?: Maybe<Tenant>;
  getTheme: Theme;
  getTimesheetsForApproval: PaginatedTimesheetApprovalResponse;
  getUser?: Maybe<User>;
  getUsersAvailableForJob?: Maybe<Array<User>>;
  getUsersAvailableForJobCriteria?: Maybe<Array<User>>;
  getUsersByClientId?: Maybe<Array<User>>;
  getUsersByTenantId?: Maybe<Array<User>>;
  getUsersByTenantIdPaginated?: Maybe<PaginatedUserResponse>;
  getWorkersByClientId?: Maybe<Array<User>>;
  getWorkersOnShiftForDateRange: Array<Maybe<DashboardWorkerOnShiftResponse>>;
  heartbeat?: Maybe<Scalars['String']['output']>;
  jobAdderAuthUrl: Scalars['String']['output'];
  jobsContributingToReliabilityScore: Array<ReliabilityScoreInfluence>;
  listMcpApiKeys: Array<McpApiKey>;
  listMcpOAuthSessions: Array<McpOAuthSession>;
  listOfUsersWithMcpAccess: Array<User>;
  messageAttachmentUrl: Scalars['String']['output'];
  messagesForChatRoom: ChatMessagePaginatedResponse;
  performHealthCheckForIntegrationsForTenant?: Maybe<Array<Scalars['JSON']['output']>>;
  precheckAbsorbClient: AbsorbClientPrecheck;
  precheckAbsorbSite: AbsorbSitePrecheck;
  precheckDuplicateSitesForTenant: DuplicateSitesPrecheck;
  precheckMergeClients: MergeClientsPrecheck;
  predictiveShiftReport: Array<Maybe<ShiftReportResult>>;
  recruiterForWorker?: Maybe<User>;
  shiftReport: Array<Maybe<ShiftReportResult>>;
  templateForTenant: Template;
  unfilledShiftReport: Array<Maybe<UnfilledShiftReportResult>>;
  usagePlan: UsagePlan;
  verifyContractStatus?: Maybe<Array<ContractStatus>>;
  workersForRecruiter: Array<Maybe<User>>;
};


export type QueryAstute_GetIdentifierPolicyArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryAstute_GetOccupationLibrariesArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryAstute_PreCheckPayRunArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryAts_ExploreArgs = {
  attemptToFindMatchingData?: InputMaybe<Scalars['Boolean']['input']>;
  integration: Ats_ExplorableIntegration;
  query: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryAts_GetExplorerSchemaArgs = {
  integration: Ats_ExplorableIntegration;
  tenantId: Scalars['String']['input'];
};


export type QueryBullhorn_GetConfigurationArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryExternal_FindRecordsArgs = {
  objectId: Scalars['String']['input'];
  objectType: External_FindableObject;
  tenantId: Scalars['String']['input'];
};


export type QueryJobadder_GetInboundImportPolicyArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryChatRoomForJobArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryChatRoomsForClientArgs = {
  clientId: Scalars['String']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatRoomsForTenantArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};


export type QueryChatRoomsForUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryCredentialsForIntegrationConnectionArgs = {
  integrationConnectionId: Scalars['String']['input'];
};


export type QueryFetchCustomAttributesForObjectIdArgs = {
  objectId: Scalars['String']['input'];
  table?: InputMaybe<TableName>;
};


export type QueryFetchExternalReferencesForObjectIdArgs = {
  objectId: Scalars['String']['input'];
  table?: InputMaybe<TableName>;
};


export type QueryGetAiResponseArgs = {
  args?: InputMaybe<Scalars['JSON']['input']>;
  prompt: AiPromptType;
};


export type QueryGetAllClientsArgs = {
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllClientsForTenantArgs = {
  forceFetchAll?: InputMaybe<Scalars['Boolean']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};


export type QueryGetAllJobsByStatusForUserIdArgs = {
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<JobStatus>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllJobsForClientArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<JobStatus>>;
};


export type QueryGetAllJobsForClientBetweenDatesArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<JobStatus>>;
};


export type QueryGetAllJobsForSiteArgs = {
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['String']['input'];
  status?: InputMaybe<Array<JobStatus>>;
};


export type QueryGetAllJobsForTenantArgs = {
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<JobStatus>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllJobsForTenantBetweenDatesArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  includeApplicationCounts?: InputMaybe<Scalars['Boolean']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<JobStatus>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllPotentialJobsForUserIdArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllSmartListsForUserArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllThemesArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetAssetArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAssetTemplatesForTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetAssetsForUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetAuditLogForObjectArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetBlockedUsersForOwnerArgs = {
  blockedUserRole?: InputMaybe<UserRole>;
  ownerId: Scalars['String']['input'];
  ownerType: BlockedUserOwnerType;
};


export type QueryGetBlocksForUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetBudgetLimitsArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetClassificationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetClassificationAssetMappingForTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetClassificationGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetClassificationGroupsArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClassificationLevelClientRatesArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetClientArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetClientPeriodBillArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetClientRateCardArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetContractArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetContractTemplateArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetContractsByOwnerIdArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryGetCoreLoopConfigurationArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetCurrentRatingForUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetCustomAttributeConfigurationsArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomerByTenantIdArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetDaySequenceByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetDaySequenceForJobForDateArgs = {
  dateISO: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};


export type QueryGetDaySequencesByJobIdsArgs = {
  jobIds: Array<Scalars['String']['input']>;
};


export type QueryGetDaySequencesForClientArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetDaySequencesForJobArgs = {
  jobId: Scalars['String']['input'];
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDaySequencesForUserArgs = {
  statuses?: InputMaybe<Array<DaySequenceStatus>>;
  userId: Scalars['String']['input'];
};


export type QueryGetDaySequencesRequiringActionArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type QueryGetEmailTemplateArgs = {
  tenantId: Scalars['String']['input'];
  type?: InputMaybe<EmailTemplateType>;
};


export type QueryGetEmailTemplatesArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetFavouriteUsersArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetInboxForOwnerArgs = {
  ownerId: Scalars['String']['input'];
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetInboxItemArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIntegrationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIntegrationConnectionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIntegrationConnectionsForTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetInviteByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetInvitesSentByUserArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetInvoicesForClientArgs = {
  clientId: Scalars['String']['input'];
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetInvoicesForClientWithStatusArgs = {
  clientId: Scalars['String']['input'];
  itemStatus: InvoiceStatus;
};


export type QueryGetInvoicesForTenantArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetInvoicesForTenantWithStatusArgs = {
  itemStatus: InvoiceStatus;
  tenantId: Scalars['String']['input'];
};


export type QueryGetJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetJobApplicationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetJobApplicationsForClientArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobApplicationStatus>;
};


export type QueryGetJobApplicationsForJobArgs = {
  jobId: Scalars['String']['input'];
  status?: InputMaybe<JobApplicationStatus>;
};


export type QueryGetJobApplicationsForTenantArgs = {
  status?: InputMaybe<JobApplicationStatus>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetJobApplicationsForUserArgs = {
  status?: InputMaybe<JobApplicationStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetJobPostingQuestionnaireArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetListArgs = {
  id: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryGetListsForOwnerArgs = {
  ownerId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryGetMcpLogsForUserArgs = {
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryGetMissingTimesheetsArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryGetNoteByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetNotesForObjectArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetOnboardingForUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetOnboardingQuestionsForTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetOnboardingTemplateArgs = {
  role: OnboardingRole;
  tenantId: Scalars['String']['input'];
};


export type QueryGetOutstandingInvitesForClientArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOutstandingInvitesForTenantArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPayRunArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPayRunCycleLogArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPayRunCycleLogsArgs = {
  periodEndISO: Scalars['String']['input'];
  periodStartISO: Scalars['String']['input'];
  status?: InputMaybe<PayRunCycleLogStatus>;
  tenantId: Scalars['String']['input'];
};


export type QueryGetPayRunReadynessArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type QueryGetPaymentMethodByCustomerIdArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetPendingWorkerRatingsForClientArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetPoliciesByOwnerIdArgs = {
  ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPolicyArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPolicyTemplateArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPolicyTemplatesByTenantIdArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetReviewArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetReviewsForObjectArgs = {
  objectId: Scalars['String']['input'];
  reviewedObjectType: ObjectType;
  tenantId: Scalars['String']['input'];
};


export type QueryGetSiteArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetSitesForClientArgs = {
  clientId: Scalars['String']['input'];
  status?: InputMaybe<Array<SiteStatus>>;
};


export type QueryGetSmartListArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTemplatesByTenantIdArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTenantArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetThemeArgs = {
  tenantId: Scalars['String']['input'];
  type: ThemeType;
};


export type QueryGetTimesheetsForApprovalArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
  view: TimesheetApprovalView;
};


export type QueryGetUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetUsersAvailableForJobArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryGetUsersAvailableForJobCriteriaArgs = {
  classificationId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['String']['input'];
};


export type QueryGetUsersByClientIdArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetUsersByTenantIdArgs = {
  roles?: InputMaybe<Array<UserRole>>;
  tenantId: Scalars['String']['input'];
};


export type QueryGetUsersByTenantIdPaginatedArgs = {
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<Array<UserRole>>;
  tenantId: Scalars['String']['input'];
};


export type QueryGetWorkersByClientIdArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetWorkersOnShiftForDateRangeArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobAdderAuthUrlArgs = {
  environment: IntegrationEnvironment;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type QueryJobsContributingToReliabilityScoreArgs = {
  userId: Scalars['String']['input'];
};


export type QueryListOfUsersWithMcpAccessArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessageAttachmentUrlArgs = {
  messageId: Scalars['String']['input'];
};


export type QueryMessagesForChatRoomArgs = {
  chatRoomId: Scalars['String']['input'];
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPerformHealthCheckForIntegrationsForTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryPrecheckAbsorbClientArgs = {
  sourceClientId: Scalars['String']['input'];
  targetClientId: Scalars['String']['input'];
};


export type QueryPrecheckAbsorbSiteArgs = {
  sourceSiteId: Scalars['String']['input'];
  targetSiteId: Scalars['String']['input'];
};


export type QueryPrecheckDuplicateSitesForTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryPrecheckMergeClientsArgs = {
  clientIds: Array<Scalars['String']['input']>;
  referenceClientId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPredictiveShiftReportArgs = {
  endDate: Scalars['String']['input'];
  includeUnfilledShifts?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecruiterForWorkerArgs = {
  id: Scalars['String']['input'];
};


export type QueryShiftReportArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplateForTenantArgs = {
  id: Scalars['String']['input'];
};


export type QueryUnfilledShiftReportArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsagePlanArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryVerifyContractStatusArgs = {
  ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkersForRecruiterArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum QueryTypes {
  Owner = 'OWNER'
}

export type QuestionOption = {
  __typename?: 'QuestionOption';
  label: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type QuestionOptionInput = {
  label: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type QuestionValidation = {
  __typename?: 'QuestionValidation';
  errorMessage: Scalars['String']['output'];
  type: QuestionValidationType;
  value: Scalars['String']['output'];
};

export type QuestionValidationInput = {
  errorMessage: Scalars['String']['input'];
  type: QuestionValidationType;
  value: Scalars['String']['input'];
};

export enum QuestionValidationType {
  FileTypes = 'FILE_TYPES',
  MaxAge = 'MAX_AGE',
  MaxDate = 'MAX_DATE',
  MaxLength = 'MAX_LENGTH',
  MaxValue = 'MAX_VALUE',
  MinAge = 'MIN_AGE',
  MinDate = 'MIN_DATE',
  MinLength = 'MIN_LENGTH',
  MinValue = 'MIN_VALUE',
  Regex = 'REGEX',
  Required = 'REQUIRED'
}

export type QuestionVisibility = {
  __typename?: 'QuestionVisibility';
  op: QuestionVisibilityOp;
  values: Array<Scalars['String']['output']>;
};

export type QuestionVisibilityInput = {
  op: QuestionVisibilityOp;
  values: Array<Scalars['String']['input']>;
};

export enum QuestionVisibilityOp {
  ParentValueIn = 'PARENT_VALUE_IN'
}

export type Questionnaire = {
  __typename?: 'Questionnaire';
  questions: Array<Maybe<QuestionnaireQuestion>>;
};

export type QuestionnaireInput = {
  responses?: InputMaybe<Array<InputMaybe<QuestionnaireResponseInput>>>;
};

export type QuestionnaireQuestion = {
  __typename?: 'QuestionnaireQuestion';
  answerType: ValueType;
  id: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<QuestionOption>>>;
  priority: Scalars['Int']['output'];
  questionTitle: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type QuestionnaireResponseInput = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
  valueType: ValueType;
};

export enum RateCardTierType {
  Flat = 'FLAT',
  PerDay = 'PER_DAY'
}

export enum ReliabilityScoreContributionDirection {
  Excluded = 'EXCLUDED',
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type ReliabilityScoreInfluence = {
  __typename?: 'ReliabilityScoreInfluence';
  contributionDirection: ReliabilityScoreContributionDirection;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export enum ReliabilityScoreInfluenceDirection {
  Excluded = 'EXCLUDED',
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type Review = {
  __typename?: 'Review';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  reviewedByUserId: Scalars['String']['output'];
  reviewedObjectType: ObjectType;
  status: ReviewStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Float']['input'];
  reviewedByUserId: Scalars['String']['input'];
  reviewedObjectId: Scalars['String']['input'];
  reviewedObjectType: ObjectType;
  status?: InputMaybe<ReviewStatus>;
  tenantId: Scalars['String']['input'];
};

export enum ReviewStatus {
  Dismissed = 'DISMISSED',
  Rated = 'RATED'
}

export type RevokeMcpApiKeysResult = {
  __typename?: 'RevokeMcpApiKeysResult';
  alreadyRevokedCount: Scalars['Int']['output'];
  revokedCount: Scalars['Int']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum S3UploadType {
  Asset = 'ASSET',
  ClientLogo = 'CLIENT_LOGO',
  Contract = 'CONTRACT',
  Invoice = 'INVOICE',
  JobApplication = 'JOB_APPLICATION',
  JobPostingPhoto = 'JOB_POSTING_PHOTO',
  Misc = 'MISC',
  Other = 'OTHER',
  PayRunReport = 'PAY_RUN_REPORT',
  Policy = 'POLICY',
  ProfilePicture = 'PROFILE_PICTURE',
  TenantLogo = 'TENANT_LOGO',
  TenantSplashScreen = 'TENANT_SPLASH_SCREEN'
}

export type SetupIntent = {
  __typename?: 'SetupIntent';
  clientSecret: Scalars['String']['output'];
};

export type ShiftReportResult = {
  __typename?: 'ShiftReportResult';
  assignedUserEmail?: Maybe<Scalars['String']['output']>;
  assignedUserId?: Maybe<Scalars['String']['output']>;
  assignedUserName?: Maybe<Scalars['String']['output']>;
  breakNotes?: Maybe<Scalars['String']['output']>;
  candidatePayRateCents?: Maybe<Scalars['Int']['output']>;
  classificationGroupId?: Maybe<Scalars['String']['output']>;
  classificationGroupName?: Maybe<Scalars['String']['output']>;
  classificationId?: Maybe<Scalars['String']['output']>;
  classificationLevelId?: Maybe<Scalars['String']['output']>;
  classificationLevelName?: Maybe<Scalars['String']['output']>;
  classificationName?: Maybe<Scalars['String']['output']>;
  clientChargeRateCents?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clockInTime: Scalars['String']['output'];
  clockOutTime: Scalars['String']['output'];
  daySequenceId?: Maybe<Scalars['String']['output']>;
  daySequenceStatus?: Maybe<DaySequenceStatus>;
  jobAddress?: Maybe<Scalars['String']['output']>;
  jobEndDate: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  jobStartDate: Scalars['String']['output'];
  jobStatus?: Maybe<JobStatus>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  shiftDate: Scalars['String']['output'];
  shiftDurationMinutes?: Maybe<Scalars['Int']['output']>;
  shiftDurationPayableMinutes?: Maybe<Scalars['Int']['output']>;
  siteId?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  totalBreakDurationMinutes?: Maybe<Scalars['String']['output']>;
};

export type Site = {
  __typename?: 'Site';
  address?: Maybe<Address>;
  addressHash?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  contactNumber?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<SiteContact>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customAttributes: Array<Maybe<CustomAttribute>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latLng?: Maybe<LatLng>;
  name: Scalars['String']['output'];
  primaryContactId?: Maybe<Scalars['String']['output']>;
  status: SiteStatus;
  tenantId: Scalars['String']['output'];
};

export type SiteContact = {
  __typename?: 'SiteContact';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SiteContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SiteInput = {
  address?: InputMaybe<AddressInput>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<SiteContactInput>>;
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  latLng?: InputMaybe<LatLngInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryContactId?: InputMaybe<Scalars['String']['input']>;
};

export enum SiteStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type SmartList = {
  __typename?: 'SmartList';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  json: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  objectType: ObjectType;
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SmartListInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  json?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<ObjectType>;
};

export type StoredCredential = {
  __typename?: 'StoredCredential';
  integrationConnectionId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum SupportedIntegrationPlatform {
  Astute = 'ASTUTE',
  Bullhorn = 'BULLHORN',
  Hubspot = 'HUBSPOT',
  Jobadder = 'JOBADDER',
  Keypay = 'KEYPAY',
  Vevo = 'VEVO'
}

export enum SupportedLanguage {
  Arabic = 'ARABIC',
  Cantonese = 'CANTONESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Lao = 'LAO',
  Mandarin = 'MANDARIN',
  Spanish = 'SPANISH',
  Tagalog = 'TAGALOG',
  Thai = 'THAI',
  Vietnamese = 'VIETNAMESE'
}

export enum TableName {
  DaySequence = 'DAY_SEQUENCE',
  DelegateQueue = 'DELEGATE_QUEUE',
  Graveyard = 'GRAVEYARD',
  Inbox = 'INBOX',
  Main = 'MAIN',
  RapidLookup = 'RAPID_LOOKUP'
}

export type TaxDetails = {
  __typename?: 'TaxDetails';
  taxNumber?: Maybe<Scalars['String']['output']>;
};

export type TaxDetailsInput = {
  taxNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Template = {
  __typename?: 'Template';
  _ASSET_LIST_: Array<AssetTemplate>;
  _CANCEL_TERM_: Scalars['String']['output'];
  _CLIENT_TERM_: Scalars['String']['output'];
  _INVOICE_NUMBER_PREFIX_: Scalars['String']['output'];
  _INVOICE_TERMS_: Scalars['String']['output'];
  _JOB_TABLE_FRONT_COLUMNS_: Array<Scalars['String']['output']>;
  _JOB_TERM_: Scalars['String']['output'];
  _PAY_RATE_LEVEL_TERM_: Scalars['String']['output'];
  _TENANT_TERM_: Scalars['String']['output'];
  _WORKER_TERM_: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Tenant = {
  __typename?: 'Tenant';
  approvalStatus?: Maybe<TenantApprovalStatus>;
  customAttributes?: Maybe<Array<CustomAttribute>>;
  id: Scalars['String']['output'];
  logoKey?: Maybe<Scalars['String']['output']>;
  logoLastSignedUrlAt?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tenantApps?: Maybe<Array<TenantApp>>;
};

export type TenantApp = {
  __typename?: 'TenantApp';
  appleUrl?: Maybe<Scalars['String']['output']>;
  googleUrl?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  type: AppContext;
};

export type TenantAppInput = {
  appleUrl?: InputMaybe<Scalars['String']['input']>;
  googleUrl?: InputMaybe<Scalars['String']['input']>;
  type: AppContext;
};

export enum TenantApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED'
}

export type TenantInput = {
  customAttributes?: InputMaybe<Array<CustomAttributeInput>>;
  firebaseProjectId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type TenantOnboarding = {
  __typename?: 'TenantOnboarding';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  pages: Array<OnboardingPage>;
  role: OnboardingRole;
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type Theme = {
  __typename?: 'Theme';
  actionColor: Scalars['String']['output'];
  actionColor10: Scalars['String']['output'];
  actionColor20: Scalars['String']['output'];
  actionColor30: Scalars['String']['output'];
  actionColor40: Scalars['String']['output'];
  actionColor50: Scalars['String']['output'];
  actionColor60: Scalars['String']['output'];
  actionColor70: Scalars['String']['output'];
  actionColor80: Scalars['String']['output'];
  actionColor90: Scalars['String']['output'];
  actionColor100: Scalars['String']['output'];
  backgroundColor: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  errorColor: Scalars['String']['output'];
  errorColor15: Scalars['String']['output'];
  errorColor50: Scalars['String']['output'];
  faviconUrl: Scalars['String']['output'];
  fontSize: Scalars['String']['output'];
  id: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
  navBackgroundColor: Scalars['String']['output'];
  primaryBrandColor: Scalars['String']['output'];
  primaryBrandColor10: Scalars['String']['output'];
  primaryBrandColor20: Scalars['String']['output'];
  primaryBrandColor30: Scalars['String']['output'];
  primaryBrandColor40: Scalars['String']['output'];
  primaryBrandColor50: Scalars['String']['output'];
  primaryBrandColor60: Scalars['String']['output'];
  primaryBrandColor70: Scalars['String']['output'];
  primaryBrandColor80: Scalars['String']['output'];
  primaryBrandColor90: Scalars['String']['output'];
  primaryBrandColor100: Scalars['String']['output'];
  primaryFont: Scalars['String']['output'];
  secondaryBrandColor: Scalars['String']['output'];
  secondaryBrandColor10: Scalars['String']['output'];
  secondaryBrandColor20: Scalars['String']['output'];
  secondaryBrandColor30: Scalars['String']['output'];
  secondaryBrandColor40: Scalars['String']['output'];
  secondaryBrandColor50: Scalars['String']['output'];
  secondaryBrandColor60: Scalars['String']['output'];
  secondaryBrandColor70: Scalars['String']['output'];
  secondaryBrandColor80: Scalars['String']['output'];
  secondaryBrandColor90: Scalars['String']['output'];
  secondaryBrandColor100: Scalars['String']['output'];
  subtleTextColor: Scalars['String']['output'];
  subtleTextColor10: Scalars['String']['output'];
  subtleTextColor20: Scalars['String']['output'];
  subtleTextColor30: Scalars['String']['output'];
  subtleTextColor40: Scalars['String']['output'];
  subtleTextColor50: Scalars['String']['output'];
  subtleTextColor60: Scalars['String']['output'];
  subtleTextColor70: Scalars['String']['output'];
  subtleTextColor80: Scalars['String']['output'];
  subtleTextColor90: Scalars['String']['output'];
  subtleTextColor100: Scalars['String']['output'];
  successColor: Scalars['String']['output'];
  successColor15: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  textDarkColor: Scalars['String']['output'];
  textLightColor: Scalars['String']['output'];
  type: ThemeType;
  updatedAt: Scalars['String']['output'];
  warningColor: Scalars['String']['output'];
  warningColor15: Scalars['String']['output'];
};

export type ThemeInput = {
  actionColor?: InputMaybe<Scalars['String']['input']>;
  actionColor10?: InputMaybe<Scalars['String']['input']>;
  actionColor20?: InputMaybe<Scalars['String']['input']>;
  actionColor30?: InputMaybe<Scalars['String']['input']>;
  actionColor40?: InputMaybe<Scalars['String']['input']>;
  actionColor50?: InputMaybe<Scalars['String']['input']>;
  actionColor60?: InputMaybe<Scalars['String']['input']>;
  actionColor70?: InputMaybe<Scalars['String']['input']>;
  actionColor80?: InputMaybe<Scalars['String']['input']>;
  actionColor90?: InputMaybe<Scalars['String']['input']>;
  actionColor100?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  errorColor?: InputMaybe<Scalars['String']['input']>;
  errorColor15?: InputMaybe<Scalars['String']['input']>;
  errorColor50?: InputMaybe<Scalars['String']['input']>;
  faviconUrl?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  navBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor10?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor20?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor30?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor40?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor50?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor60?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor70?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor80?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor90?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor100?: InputMaybe<Scalars['String']['input']>;
  primaryFont?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor10?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor20?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor30?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor40?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor50?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor60?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor70?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor80?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor90?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor100?: InputMaybe<Scalars['String']['input']>;
  subtleTextColor?: InputMaybe<Scalars['String']['input']>;
  subtleTextColor10?: InputMaybe<Scalars['String']['input']>;
  subtleTextColor20?: InputMaybe<Scalars['String']['input']>;
  subtleTextColor30?: InputMaybe<Scalars['String']['input']>;
  subtleTextColor40?: InputMaybe<Scalars['String']['input']>;
  subtleTextColor50?: InputMaybe<Scalars['String']['input']>;
  subtleTextColor60?: InputMaybe<Scalars['String']['input']>;
  subtleTextColor70?: InputMaybe<Scalars['String']['input']>;
  subtleTextColor80?: InputMaybe<Scalars['String']['input']>;
  subtleTextColor90?: InputMaybe<Scalars['String']['input']>;
  subtleTextColor100?: InputMaybe<Scalars['String']['input']>;
  successColor?: InputMaybe<Scalars['String']['input']>;
  successColor15?: InputMaybe<Scalars['String']['input']>;
  textDarkColor?: InputMaybe<Scalars['String']['input']>;
  textLightColor?: InputMaybe<Scalars['String']['input']>;
  warningColor?: InputMaybe<Scalars['String']['input']>;
  warningColor15?: InputMaybe<Scalars['String']['input']>;
};

export enum ThemeType {
  ClientApp = 'CLIENT_APP',
  ClientWeb = 'CLIENT_WEB',
  HqApp = 'HQ_APP',
  HqWeb = 'HQ_WEB',
  Portal = 'PORTAL',
  TenantApp = 'TENANT_APP',
  TenantWeb = 'TENANT_WEB',
  WorkerApp = 'WORKER_APP',
  WorkerWeb = 'WORKER_WEB'
}

export enum ThrottleLimitCategory {
  DeletesPerMinute = 'DELETES_PER_MINUTE',
  NotificationsPerMinute = 'NOTIFICATIONS_PER_MINUTE',
  ReadsPerMinute = 'READS_PER_MINUTE',
  UpdatesPerMinute = 'UPDATES_PER_MINUTE',
  WritesPerMinute = 'WRITES_PER_MINUTE'
}

export enum TimeUnit {
  Days = 'DAYS',
  Fortnight = 'FORTNIGHT',
  Hours = 'HOURS',
  Milliseconds = 'MILLISECONDS',
  Minutes = 'MINUTES',
  Seconds = 'SECONDS',
  Weeks = 'WEEKS',
  Years = 'YEARS'
}

export type TimesheetApprovalItem = {
  __typename?: 'TimesheetApprovalItem';
  clientId: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  daySequence: DaySequence;
  jobTimezone?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  workType?: Maybe<Scalars['String']['output']>;
  workerName?: Maybe<Scalars['String']['output']>;
  workerProfileImageUrl?: Maybe<Scalars['String']['output']>;
};

export enum TimesheetApprovalView {
  Approved = 'APPROVED',
  Pending = 'PENDING'
}

export type UnfilledShiftReportResult = {
  __typename?: 'UnfilledShiftReportResult';
  classificationGroupId?: Maybe<Scalars['String']['output']>;
  classificationGroupName?: Maybe<Scalars['String']['output']>;
  classificationId?: Maybe<Scalars['String']['output']>;
  classificationName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  intendedShiftClockInTime?: Maybe<Scalars['String']['output']>;
  intendedShiftClockOutTime?: Maybe<Scalars['String']['output']>;
  intendedShiftDurationMinutes?: Maybe<Scalars['Int']['output']>;
  jobAddress?: Maybe<Scalars['String']['output']>;
  jobDescription?: Maybe<Scalars['String']['output']>;
  jobEndDate: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  jobStartDate: Scalars['String']['output'];
  jobStatus?: Maybe<JobStatus>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  shiftDate: Scalars['String']['output'];
  siteId?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
};

export type Update = {
  __typename?: 'Update';
  attributeName: Scalars['String']['output'];
  error?: Maybe<PartialUpdateError>;
  fieldKey?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  objectId: Scalars['String']['output'];
  objectType: ObjectType;
  oldValue?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateJobInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
  classificationId?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeInput>>>;
  days?: InputMaybe<MultiDayInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  marginPercentage?: InputMaybe<Scalars['Float']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workersShouldApplyToJob?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadFileInput = {
  fileBytes?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<AssetFileType>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  objectId?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  type: UploadType;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFileResponse = {
  __typename?: 'UploadFileResponse';
  key: Scalars['String']['output'];
  parentId: Scalars['String']['output'];
  type: UploadType;
  url: Scalars['String']['output'];
};

export enum UploadType {
  Asset = 'ASSET',
  ClientLogo = 'CLIENT_LOGO',
  ProfilePicture = 'PROFILE_PICTURE',
  TenantLogo = 'TENANT_LOGO',
  TenantSplashScreen = 'TENANT_SPLASH_SCREEN'
}

export type UsagePlan = {
  __typename?: 'UsagePlan';
  currentMonth: Scalars['String']['output'];
  currentUsage: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  toolInvocationMonthlyLimit: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  addressHash?: Maybe<Scalars['String']['output']>;
  assignedAdminId?: Maybe<Scalars['String']['output']>;
  classificationIds: Array<Scalars['String']['output']>;
  classificationLevelIds: Array<Scalars['String']['output']>;
  classificationLevels: Array<Maybe<ClassificationLevel>>;
  classifications: Array<Maybe<Classification>>;
  clientId?: Maybe<Scalars['String']['output']>;
  cognitoCreatedAt?: Maybe<Scalars['String']['output']>;
  cognitoSub?: Maybe<Scalars['String']['output']>;
  customAttributes: Array<Maybe<CustomAttribute>>;
  cvProfile?: Maybe<UserCvProfile>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employmentDetails?: Maybe<EmploymentDetails>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idealRadius?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latLng?: Maybe<LatLng>;
  onboardingCompletedAtTemplateId?: Maybe<Scalars['String']['output']>;
  onboardingPercentage?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<SupportedLanguage>;
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use cvProfile.summary instead */
  profileSummary?: Maybe<Scalars['String']['output']>;
  reliabilityScore?: Maybe<Scalars['Float']['output']>;
  role?: Maybe<UserRole>;
  siteIds?: Maybe<Array<Scalars['String']['output']>>;
  sites?: Maybe<Array<Site>>;
  status: UserStatus;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  vevoCheck?: Maybe<VevoCheck>;
};


export type UserCustomAttributesArgs = {
  refs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserCvProfile = {
  __typename?: 'UserCvProfile';
  aiGeneratedAt?: Maybe<Scalars['String']['output']>;
  humanEditedAt?: Maybe<Scalars['String']['output']>;
  isAiGenerated: Scalars['Boolean']['output'];
  priorityEngagementPoints: Array<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
};

export type UserCvProfileInput = {
  priorityEngagementPoints: Array<Scalars['String']['input']>;
  summary: Scalars['String']['input'];
};

export type UserInput = {
  address?: InputMaybe<AddressInput>;
  assignedAdminId?: InputMaybe<Scalars['String']['input']>;
  classificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  classificationLevelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  cognitoSub?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Array<CustomAttributeInput>>;
  cvProfile?: InputMaybe<UserCvProfileInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentDetails?: InputMaybe<EmploymentDetailsInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idealRadius?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  latLng?: InputMaybe<LatLngInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<SupportedLanguage>;
  role?: InputMaybe<UserRole>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export enum UserRole {
  ClientAdmin = 'CLIENT_ADMIN',
  ClientUser = 'CLIENT_USER',
  ClientViewer = 'CLIENT_VIEWER',
  HqAdmin = 'HQ_ADMIN',
  TenantAdmin = 'TENANT_ADMIN',
  TenantRecruiter = 'TENANT_RECRUITER',
  TenantUser = 'TENANT_USER',
  Unknown = 'UNKNOWN',
  Worker = 'WORKER'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  DocsExpired = 'DOCS_EXPIRED',
  OnHold = 'ON_HOLD',
  Pending = 'PENDING',
  PendingReview = 'PENDING_REVIEW',
  Suspended = 'SUSPENDED',
  Terminated = 'TERMINATED'
}

export enum ValueType {
  Array = 'ARRAY',
  Asset = 'ASSET',
  Boolean = 'BOOLEAN',
  Contract = 'CONTRACT',
  Number = 'NUMBER',
  Object = 'OBJECT',
  Policy = 'POLICY',
  String = 'STRING'
}

export type VevoCheck = {
  __typename?: 'VevoCheck';
  confirmationTimestamp?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  maxHourLimit?: Maybe<Scalars['Float']['output']>;
  passportExpiry?: Maybe<Scalars['String']['output']>;
  passportIssueCountry?: Maybe<Scalars['String']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  residencyStatus?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  vevoCheckTimestamp?: Maybe<Scalars['String']['output']>;
  vevoCheckVisaExpiry?: Maybe<Scalars['String']['output']>;
  vevoCheckVisaSubClassCode?: Maybe<Scalars['String']['output']>;
  vevoCheckWorkConditionCode?: Maybe<Scalars['String']['output']>;
  vevoCheckWorkEntitlementStatus?: Maybe<Scalars['String']['output']>;
};

export enum WorkType {
  Contract = 'CONTRACT',
  DayToDay = 'DAY_TO_DAY',
  FlexibleContract = 'FLEXIBLE_CONTRACT',
  Unknown = 'UNKNOWN'
}

export enum WorkerCountCriteria {
  ActiveWorkers = 'ACTIVE_WORKERS',
  AllWorkers = 'ALL_WORKERS',
  ClockedInNow = 'CLOCKED_IN_NOW',
  OnShiftToday = 'ON_SHIFT_TODAY'
}

export type WorkerStats = {
  __typename?: 'WorkerStats';
  earningsForPeriod?: Maybe<Scalars['Int']['output']>;
  streak?: Maybe<Scalars['Int']['output']>;
  upcomingEarningsForPeriod?: Maybe<Scalars['Int']['output']>;
};
